{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2017 - 2021                               }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSWEBPersistence;

//{$DEFINE RTLONLY}

{$IFNDEF RTLONLY}
{$I WEBLib.TMSWEBDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$ELSE}
//RTL ONLY
{$IFDEF IOS}
{$IFNDEF VER340}
{$IFNDEF VER350}
{$IFNDEF VER360}
{$DEFINE ZEROSTRINGINDEX}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$IFDEF ANDROID}
{$IFNDEF VER340}
{$IFNDEF VER350}
{$IFNDEF VER360}
{$DEFINE ZEROSTRINGINDEX}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}
{$ENDIF}

interface

uses
  {$IFDEF MSWINDOWS}
  Windows,
  {$ENDIF}
  {$IFDEF LCLLIB}
  fgl,
  {$IFNDEF MSWINDOWS}
  LCLIntF,
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  Generics.Collections,
  {$ENDIF}
  Classes, TypInfo, Variants, SysUtils,
  WEBLib.TMSWEBTypes,
  WEBLib.TMSWEBJSONReader,
  WEBLib.TMSWEBJSONWriter
  {$IFDEF FNCLIB}
  {$IFDEF WEBLIB}
  ,WEBLib.JSON
  {$ENDIF}
  {$IFDEF FMXLIB}
  ,JSON
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,JSON
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,fpjson
  {$ENDIF}
  {$ENDIF}
  ;

type
  ITMSWEBPersistence = interface
  ['{363F04AF-B8A7-4C47-A2D6-8ED9C44CEFF6}']
    procedure SaveSettingsToFile(AFileName: string; AAppearanceOnly: Boolean = False);
    procedure LoadSettingsFromFile(AFileName: string);
    procedure SaveSettingsToStream(AStream: TStream; AAppearanceOnly: Boolean = False);
    procedure LoadSettingsFromStream(AStream: TStream);
    function CanSaveProperty(AObject: TObject; APropertyName: string; APropertyType: TTypeKind): Boolean;
    function CanLoadProperty(AObject: TObject; APropertyName: string; APropertyType: TTypeKind): Boolean;
  end;

  ITMSWEBCustomReadWriteIO = interface
  ['{3BC2E91F-A937-47EE-A4CB-6F705B154901}']
    procedure CustomWriteProperty(AObject: TObject; APropertyName: string; APropertyKind: TTypeKind; AWriter: TTMSWEBJSONWriter; var ACanWrite: Boolean);
    procedure CustomReadProperty(AObject: TObject; APropertyName: string; APropertyKind: TTypeKind; AReader: TTMSWEBJSONReader; var ACanRead: Boolean);
  end;

  ITMSWEBBaseListIO = interface
  ['{FAB1D21E-D798-4CE0-B17B-9D75E4456AB4}']
    function GetItemClass: TClass;
  end;

  ITMSWEBBasePersistenceIO = interface
    ['{91DEAFC3-8932-45F4-A3ED-5AAA0C0E9250}']
    function CreateObject(const AClassName: string; const ABaseClass: TClass): TObject;
  end;

  ITMSWEBBaseCollectionIO = interface
  ['{90FDF257-7362-411D-B7F6-E2BEE2265016}']
    function AddItem(const AObject: TObject): TCollectionItem;
  end;

  ITMSWEBPersistenceIO = interface(ITMSWEBBasePersistenceIO)
  ['{11B625F8-447A-4AE5-BB88-5ECDEA979AF7}']
    function NeedsObjectReference(const AClass: TClass): Boolean;
    function GetObjectReference(const AObject: TObject): string;
    function FindObject(const AReference: string): TObject;
    procedure FixOwners(const AObject: TObject; const AObjectList: TObject);
  end;

  ETMSWEBReaderException = class(Exception)
  end;

  {$IFDEF WEBLIB}
  TTMSWEBPropertyInfo = TTypeMemberProperty;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSWEBPropertyInfo = PPropInfo;
  {$ENDIF}

  TTMSWEBStringObjectDictionary = class(TDictionary<string, TObject>);
  TTMSWEBIntegerObjectDictionary = class(TDictionary<Integer, TObject>);
  TTMSWEBIntegerIntegerDictionary = class(TDictionary<Integer, Integer>);
  TTMSWEBIntegerBooleanDictionary = class(TDictionary<Integer, Boolean>);
  TTMSWEBIntegerDoubleDictionary = class(TDictionary<Integer, Double>);
  TTMSWEBObjectList = class(TObjectList<TObject>);
  TTMSWEBStringList = class(TList<string>);
  TTMSWEBIntegerList = class(TList<Integer>);
  TTMSWEBDoubleList = class(TList<Double>);

  TTMSWEBObjectArray = array of TObject;

  TTMSWEBWriterCustomWritePropertyEvent = procedure(AObject: TObject; APropertyName: string; APropertyKind: TTypeKind; AWriter: TTMSWEBJSONWriter; var ACanWrite: Boolean) of object;
  TTMSWEBWriterCustomIsAssignablePropertyEvent = procedure(AObject: TObject; APropertyName: string; var AIsAssignable: Boolean) of object;

  TTMSWEBExcludePropertyListArray = array of string;

  TTMSWEBWriter = class
  private
    FWriter: TTMSWEBJSONWriter;
    FWriterRef: Boolean;
    FIOReference: TObject;
    FOnCustomWriteProperty: TTMSWEBWriterCustomWritePropertyEvent;
    FRootObject: TObject;
    FExcludeProperties: TTMSWEBExcludePropertyListArray;
    FOnCustomIsAssignableProperty: TTMSWEBWriterCustomIsAssignablePropertyEvent;
    procedure SetRootObject(const Value: TObject);
    procedure SetExcludeProperties(
      const Value: TTMSWEBExcludePropertyListArray);
    procedure SetIOReference(const Value: TObject);
    property Writer: TTMSWEBJSONWriter read FWriter;
    procedure WritePropInfoValue(AInstance: TObject; const APropInfo: TTMSWEBPropertyInfo);
    procedure WriteProperties(AObject: TObject);
    procedure WriteProperty(AObject: TObject; AProp: TTMSWEBPropertyInfo);
    procedure WriteGenericObjectList(AList: TTMSWEBObjectList);
    procedure WriteGenericStringList(AList: TTMSWEBStringList);
    procedure WriteGenericIntegerList(AList: TTMSWEBIntegerList);
    procedure WriteGenericDoubleList(AList: TTMSWEBDoubleList);
    procedure WriteStrings(AList: TStrings);
    procedure WriteGenericStringObjectDictionary(ADictionary: TTMSWEBStringObjectDictionary);
    procedure WriteGenericIntegerObjectDictionary(ADictionary: TTMSWEBIntegerObjectDictionary);
    procedure WriteGenericIntegerIntegerDictionary(ADictionary: TTMSWEBIntegerIntegerDictionary);
    procedure WriteGenericIntegerBooleanDictionary(ADictionary: TTMSWEBIntegerBooleanDictionary);
    procedure WriteGenericIntegerDoubleDictionary(ADictionary: TTMSWEBIntegerDoubleDictionary);
    procedure WriteCollection(ACollection: TCollection);
    procedure WriteList(AList: TList);
    {$IFNDEF RTLONLY}
    procedure WriteBitmap(ABitmap: TTMSWEBBitmap);
    {$ENDIF}
    procedure WriteSingleObject(AObject: TObject);
    procedure WriteObject(AObject: TObject);
  public
    constructor Create(AStream: TStream); overload;
    constructor Create(AWriter: TTMSWEBJSONWriter); overload;
    destructor Destroy; override;
    procedure Write(AObject: TObject);
    procedure WriteArray(AName: string; AArray: TTMSWEBObjectArray);
    property JSONWriter: TTMSWEBJSONWriter read FWriter;
    property IOReference: TObject read FIOReference write SetIOReference;
    property RootObject: TObject read FRootObject write SetRootObject;
    property ExcludeProperties: TTMSWEBExcludePropertyListArray read FExcludeProperties write SetExcludeProperties;
    property OnCustomWriteProperty: TTMSWEBWriterCustomWritePropertyEvent read FOnCustomWriteProperty write FOnCustomWriteProperty;
    property OnCustomIsAssignableProperty: TTMSWEBWriterCustomIsAssignablePropertyEvent read FOnCustomIsAssignableProperty write FOnCustomIsAssignableProperty;
  end;

  TTMSWEBReaderCustomReadPropertyEvent = procedure(AObject: TObject; APropertyName: string; APropertyKind: TTypeKind; AReader: TTMSWEBJSONReader; var ACanRead: Boolean) of object;

  TTMSWEBObjectReference = class
  public
    Instance: TObject;
    Prop: TTMSWEBPropertyInfo;
    Id: string;
    constructor Create(AInstance: TObject; AProp: TTMSWEBPropertyInfo; const AId: string);
  end;

  TTMSWEBObjectReferences = TObjectList<TTMSWEBObjectReference>;

  TTMSWEBReader = class
  private
    FReaderRef: Boolean;
    FReferences: TTMSWEBObjectReferences;
    FReader: TTMSWEBJSONReader;
    FIOReference: TObject;
    FOnCustomReadProperty: TTMSWEBReaderCustomReadPropertyEvent;
    FRootObject: TObject;
    FExcludeProperties: TTMSWEBExcludePropertyListArray;
    FOnCustomIsAssignableProperty: TTMSWEBWriterCustomIsAssignablePropertyEvent;
    function ReadSingleObject(ABaseClass: TClass): TObject; overload;
    procedure SetRootObject(const Value: TObject);
    procedure SetExcludeProperties(
      const Value: TTMSWEBExcludePropertyListArray);
    procedure SetIOReference(const Value: TObject);
    property Reader: TTMSWEBJSONReader read FReader;
    procedure ReadSingleObject(AObject: TObject); overload;
    procedure ReadProperties(AObject: TObject);
    procedure ReadProperty(AObject: TObject; AProp: TTMSWEBPropertyInfo);
    procedure ReadPropInfoValue(AInstance: TObject; const APropInfo: TTMSWEBPropertyInfo);
    procedure ReadExistingObject(AObject: TObject);
    procedure ReadGenericStringList(AList: TTMSWEBStringList);
    procedure ReadGenericDoubleList(AList: TTMSWEBDoubleList);
    procedure ReadGenericIntegerList(AList: TTMSWEBIntegerList);
    procedure ReadStrings(AList: TStrings);
    procedure ReadGenericObjectList(AList: TTMSWEBObjectList);
    procedure ReadGenericStringObjectDictionary(ADictionary: TTMSWEBStringObjectDictionary);
    procedure ReadGenericIntegerObjectDictionary(ADictionary: TTMSWEBIntegerObjectDictionary);
    procedure ReadGenericIntegerIntegerDictionary(ADictionary: TTMSWEBIntegerIntegerDictionary);
    procedure ReadGenericIntegerBooleanDictionary(ADictionary: TTMSWEBIntegerBooleanDictionary);
    procedure ReadGenericIntegerDoubleDictionary(ADictionary: TTMSWEBIntegerDoubleDictionary);
    procedure ReadCollection(ACollection: TCollection);
    procedure ReadList(AList: TList);
    {$IFNDEF RTLONLY}
    procedure ReadBitmap(ABitmap: TTMSWEBBitmap);
    {$ENDIF}
    procedure ReadObject(AObject: TObject);
  public
    constructor Create(AStream: TStream); overload;
    constructor Create(AReader: TTMSWEBJSONReader); overload;
    destructor Destroy; override;
    function Read(AClass: TClass): TObject; overload;
    procedure Read(AObject: TObject); overload;
    function ReadArray(AName: string): TTMSWEBObjectArray; overload;
    property JSONReader: TTMSWEBJSONReader read FReader;
    property IOReference: TObject read FIOReference write SetIOReference;
    property RootObject: TObject read FRootObject write SetRootObject;
    property ExcludeProperties: TTMSWEBExcludePropertyListArray read FExcludeProperties write SetExcludeProperties;
    property OnCustomReadProperty: TTMSWEBReaderCustomReadPropertyEvent read FOnCustomReadProperty write FOnCustomReadProperty;
    property OnCustomIsAssignableProperty: TTMSWEBWriterCustomIsAssignablePropertyEvent read FOnCustomIsAssignableProperty write FOnCustomIsAssignableProperty;
    procedure SolveReferences;
  end;

  {$IFDEF WEBLIB}
  PTypeInfo = TypInfo.TTypeInfo;
  {$ELSE}
  PTypeInfo = TypInfo.PTypeInfo;
  {$ENDIF}

  TTMSWEBObjectPersistence = class
  public
    class function SaveObjectToString(AObject: TObject): string;
    class procedure LoadObjectFromString(AObject: TObject; AString: string);
  end;

  TTMSWEBPersistence = class
  public class var
    ClassTypeVariable: string;
    IgnoreExceptions: Boolean;
  private
    class var FOnCustomReadProperty: TTMSWEBReaderCustomReadPropertyEvent;
    class var FOnCustomWriteProperty: TTMSWEBWriterCustomWritePropertyEvent;
    class var FRootObject: TObject;
    class var FExcludeProperties: TTMSWEBExcludePropertyListArray;
    class var FIOReference: TObject;
    class procedure DoCustomReadProperty(AObject: TObject; APropertyName: string; APropertyKind: TTypeKind; AReader: TTMSWEBJSONReader; var ACanRead: Boolean);
    class procedure DoCustomWriteProperty(AObject: TObject; APropertyName: string; APropertyKind: TTypeKind; AWriter: TTMSWEBJSONWriter; var ACanWrite: Boolean);
  public
    class procedure SaveSettingsToFile(AObject: TObject; AFileName: string);
    class procedure LoadSettingsFromFile(AObject: TObject; AFileName: string);
    class procedure SaveSettingsToStream(AObject: TObject; AStream: TStream);
    class procedure LoadSettingsFromStream(AObject: TObject; AStream: TStream);
    class procedure GetEnumValues(AValues: TStrings; APropInfo: TTMSWEBPropertyInfo);
    class function CreateObject(const AClassName: string; BaseClass: TClass): TObject;
    class function GetPropInfoDataTypeInfo(APropInfo: TTMSWEBPropertyInfo): PTypeInfo;
    class function GetPropInfoDataTypeInfoClassType(APropInfo: TTMSWEBPropertyInfo): TClass;
    class function GetPropInfoType(APropInfo: TTMSWEBPropertyInfo): TTypeKind; virtual;
    class function GetPropInfoName(APropInfo: TTMSWEBPropertyInfo): string; virtual;
    class function GetPropInfoTypeName(APropInfo: TTMSWEBPropertyInfo): string;
    class function GetEnumName(ATypeInfo: PTypeInfo; AValue: Integer): string;
    class function IsWriteOnly(APropInfo: TTMSWEBPropertyInfo): Boolean; virtual;
    class function IsReadOnly(APropInfo: TTMSWEBPropertyInfo): Boolean; virtual;
    class function IsAssignableProperty(AObject: TObject; APropInfo: TTMSWEBPropertyInfo): Boolean; virtual;
    class function IsColor(APropertyName: string): Boolean; virtual;
    class function IsStrokeKind(APropertyName: string): Boolean; virtual;
    class function IsFillKind(APropertyName: string): Boolean; virtual;
    class function IsDate(APropertyName: string): Boolean; virtual;
    class function IsDateTime(APropertyName: string): Boolean; virtual;
    class function IsTime(APropertyName: string): Boolean; virtual;
    class function GetGenericListType(AClass: TClass): TClass; virtual;
    class function GetGenericDictionaryValueType(AClass: TClass): TClass; virtual;
    class function IsGenericDictionaryValueTypeObject(AClass: TClass): Boolean; virtual;
    class function IsGenericDictionaryValueTypeInteger(AClass: TClass): Boolean; virtual;
    class function IsGenericDictionaryValueTypeBoolean(AClass: TClass): Boolean; virtual;
    class function IsGenericDictionaryValueTypeDouble(AClass: TClass): Boolean; virtual;
    class function IsGenericList(AClass: TClass; AType: string = ''): Boolean; virtual;
    class function IsGenericDictionary(AClass: TClass): Boolean; virtual;
    class function IsGenericStringDictionary(AClass: TClass): Boolean; virtual;
    class function IsGenericIntegerDictionary(AClass: TClass): Boolean; virtual;
    class function IsCollection(AClass: TClass): Boolean; virtual;
    class function IsComponent(AClass: TClass): Boolean; virtual;
    class function IsControl(AClass: TClass): Boolean; virtual;
    class function IsList(AClass: TClass): Boolean; virtual;
    class function IsDescendingClass(AClass: TClass; AClassParentList: array of string): Boolean; virtual;
    class function IsBitmap(AClass: TClass): Boolean; virtual;
    class function IsStrings(AClass: TClass): Boolean; virtual;
    class property OnCustomWriteProperty: TTMSWEBWriterCustomWritePropertyEvent read FOnCustomWriteProperty write FOnCustomWriteProperty;
    class property OnCustomReadProperty: TTMSWEBReaderCustomReadPropertyEvent read FOnCustomReadProperty write FOnCustomReadProperty;
    class property RootObject: TObject read FRootObject write FRootObject;
    class property ExcludeProperties: TTMSWEBExcludePropertyListArray read FExcludeProperties write FExcludeProperties;
    class property IOReference: TObject read FIOReference write FIOReference;
  end;

  {$IFDEF FNCLIB}
  TTMSWEBJSONToClassPropertyType = (cptUndefined, cptString, cptBoolean, cptDateTime, cptObject, cptDouble, cptInteger,
    cptInteger64, cptObjectArray, cptStringArray, cptBooleanArray, cptDateTimeArray, cptDoubleArray, cptIntegerArray, cptInteger64Array);

  TTMSWEBJSONToClassBaseClass = (cbcNone, cbcPersistent);

  TTMSWEBJSONToClassOptions = record
    SortProperties: Boolean;
    DelphiCasing: Boolean;
    RemoveSpecialCharacters: Boolean;
    AddConstructor: Boolean;
    AddDestructor: Boolean;
    AddAssign: Boolean;
    AddUnit: Boolean;
    BaseClass: TTMSWEBJSONToClassBaseClass;
    AddImplementation: Boolean;
  end;

  TTMSWEBJSONToClassExportEvent = {$IFNDEF LCLLIB}reference to {$ENDIF}procedure(var APropertyName: string; var APropertyType: TTMSWEBJSONToClassPropertyType){$IFDEF LCLLIB} of object{$ENDIF};

  TTMSWEBJSONToClassProperty = class
  private
    FName: string;
    FType: TTMSWEBJSONToClassPropertyType;
    function FixKeyWord(AValue: string): string;
  public
    function IsObject: Boolean;
    function DelphiName(ACallBack: TTMSWEBJSONToClassExportEvent; AOptions: TTMSWEBJSONToClassOptions; AFixKeyWord: Boolean = True): string;
    function DelphiType(ACallBack: TTMSWEBJSONToClassExportEvent; AOptions: TTMSWEBJSONToClassOptions): string;
    constructor Create(AName: string; AType: TTMSWEBJSONToClassPropertyType);
    property Name: string read FName write FName;
    property &Type: TTMSWEBJSONToClassPropertyType read FType write FType;
  end;

  TTMSWEBJSONToClassProperties = class(TObjectList<TTMSWEBJSONToClassProperty>);

  TTMSWEBJSONToClassItem = class
  private
    FProperties: TTMSWEBJSONToClassProperties;
    FParentProperty: TTMSWEBJSONToClassProperty;
    function GetProperties: TTMSWEBJSONToClassProperties;
  public
    function GetClassName(ACallBack: TTMSWEBJSONToClassExportEvent; AOptions: TTMSWEBJSONToClassOptions): string;
    constructor Create(AParentProperty: TTMSWEBJSONToClassProperty);
    destructor Destroy; override;
    property Properties: TTMSWEBJSONToClassProperties read GetProperties;
    property ParentProperty: TTMSWEBJSONToClassProperty read FParentProperty;
  end;

  TTMSWEBJSONToClassItems = class(TObjectList<TTMSWEBJSONToClassItem>);

  TTMSWEBJSONToClass = class
  private
    class var FClasses: TTMSWEBJSONToClassItems;
  protected
    class procedure JSONValueToClass(AParentProperty: TTMSWEBJSONToClassProperty; AJSONValue: TJSONValue);
    class function JSONValueToPropertyType(AJSONValue: TJSONValue): TTMSWEBJSONToClassPropertyType;
  public
    class function ExportToDelphi(AJSONString: string; AOptions: TTMSWEBJSONToClassOptions; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string; overload;
    class function ExportToDelphi(AJSONString: string; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string; overload;
    class function ExportToDelphi(AJSONValue: TJSONValue; AOptions: TTMSWEBJSONToClassOptions; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string; overload;
    class function ExportToDelphi(AJSONValue: TJSONValue; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string; overload;
    class function ExportToDelphiFromFile(AFileName: string; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string; overload;
    class function ExportToDelphiFromFile(AFileName: string; AOptions: TTMSWEBJSONToClassOptions; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string; overload;
  end;
  {$ENDIF}

var
  ExcludePropertyList: array[0..58] of string = (
     'Align',
     'AllowFocus',
     'Anchors',
     'BevelEdges',
     'BevelInner',
     'BevelKind',
     'BevelOuter',
     'BevelWidth',
     'BiDiMode',
     'BitmapContainer',
     'BorderSpacing',
     'CanParentFocus',
     'ClipChildren',
     'ClipParent',
     'Constraints',
     'Ctl3D',
     'DisableFocusEffect',
     'DoubleBuffered',
     'DragCursor',
     'DragKind',
     'DragMode',
     'ElementID',
     'ElementClassName',
     'ElementPosition',
     'ElementFont',
     'Enabled',
     'EnableDragHighLight',
     'Height',
     'Hint',
     'HitTest',
     'Left',
     'Locked',
     'Margins',
     'Name',
     'Opacity',
     'Padding',
     'ParentBiDiMode',
     'ParentColor',
     'ParentCtl3D',
     'ParentDoubleBuffered',
     'ParentFont',
     'ParentShowHint',
     'PopupMenu',
     'Position',
     'RotationAngle',
     'RotationCenter',
     'Scale',
     'ShowHint',
     'Size',
     'StyleElements',
     'StyleName',
     'TabOrder',
     'TabStop',
     'Tag',
     'Top',
     'Touch',
     'TouchTargetExpansion',
     'Visible',
     'Width');

{$IFDEF FNCLIB}
function DefaultJSONToClassOptions: TTMSWEBJSONToClassOptions;
{$ENDIF}

implementation

uses
  {$IFNDEF LCLLIB}
  Rtti,
  {$ENDIF}
  {$IFDEF FMXLIB}
  UITypes,
  {$ENDIF}
  DateUtils,
  StrUtils,
  {$IFNDEF RTLONLY}
  WEBLib.Controls,
  WEBLib.Graphics,
  {$ENDIF}
  {$IFDEF WEBLIB}
  js,
  {$ENDIF}
  {$IFNDEF LCLLIB}
  Generics.Defaults,
  {$ENDIF}
  WEBLib.TMSWEBUtils;

{$IFNDEF RTLONLY}
const
  {$IFDEF FMXLIB}
  gcNull = $00000000;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  gcNull = -1;
  {$ENDIF}

type
  {$IFDEF FMXLIB}
  TTMSWEBPersistenceColor = TAlphaColor;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSWEBPersistenceColor = TColor;
  {$ENDIF}
{$ENDIF}

{$IFDEF FNCLIB}
type
  {$IFNDEF LCLWEBLIB}
  TTMSWEBJSONToClassPropertyNameComparer = class(TComparer<TTMSWEBJSONToClassProperty>)
  public
    function Compare(const Left, Right: TTMSWEBJSONToClassProperty): Integer; override;
  end;
  {$ENDIF}
{$ENDIF}

{$IFDEF FMXLIB}
  TControlClass = class of TControl;
{$ENDIF}
{$IFDEF CMNWEBLIB}
  TCustomControlClass = class of TCustomControl;
{$ENDIF}

{$IFNDEF WEBLIB}
{$IFNDEF FMXMOBILE}
{$IFNDEF LCLLIB}
type
  {$HINTS OFF}
  {$IF COMPILERVERSION < 26}
  TSymbolNameBase = string[255];
  TSymbolName = type TSymbolNameBase;
  {$IFEND}
  {$HINTS ON}
  PSymbolName = ^TSymbolName;
{$ENDIF}
{$IFDEF LCLLIB}
type
  PSymbolName = ^ShortString;
{$ENDIF}

function GetShortStringString(const ShortStringPointer: PSymbolName): string;
begin
  Result := string(ShortStringPointer^);
end;
{$ENDIF}
{$IFDEF FMXMOBILE}
function GetShortStringString(const ShortStringPointer: PByte): string;
var
  ShortStringLength: Byte;
  FirstShortStringCharacter: MarshaledAString;
  ConvertedLength: Cardinal;
  UnicodeCharacters: array[Byte] of Char;
begin
  if not Assigned(ShortStringPointer) then
    Result := ''
  else
  begin
    ShortStringLength := ShortStringPointer^;
    if ShortStringLength = 0 then
      Result := ''
    else
    begin
      FirstShortStringCharacter := MarshaledAString(ShortStringPointer+1);
      ConvertedLength := UTF8ToUnicode(
          UnicodeCharacters,
          Length(UnicodeCharacters),
          FirstShortStringCharacter,
          ShortStringLength
        );

      ConvertedLength := ConvertedLength-1;
      SetString(Result, UnicodeCharacters, ConvertedLength);
    end;
  end;
end;
{$ENDIF}
{$ENDIF}

function GetTypeInfoEx(APropInfo: TTMSWEBPropertyInfo): PTypeInfo;
begin
  {$IFNDEF WEBLIB}
  Result := APropInfo^.PropType{$IFNDEF LCLLIB}^{$ENDIF};
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := APropInfo.typeinfo;
  {$ENDIF}
end;

{$IFNDEF RTLONLY}
function GetColorRed(AColor: TTMSWEBPersistenceColor): Byte;
begin
  {$IFDEF FMXLIB}
  Result := TAlphaColorRec(AColor).R;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  AColor := ColorToRGB(AColor);
  Result := GetRValue(AColor);
  {$ENDIF}
end;

function GetColorGreen(AColor: TTMSWEBPersistenceColor): Byte;
begin
  {$IFDEF FMXLIB}
  Result := TAlphaColorRec(AColor).G;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  AColor := ColorToRGB(AColor);
  Result := GetGValue(AColor);
  {$ENDIF}
end;

function GetColorBlue(AColor: TTMSWEBPersistenceColor): Byte;
begin
  {$IFDEF FMXLIB}
  Result := TAlphaColorRec(AColor).B;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  AColor := ColorToRGB(AColor);
  Result := GetBValue(AColor);
  {$ENDIF}
end;

function HTMLToColorEx(AHTML: string): TTMSWEBPersistenceColor;

function HexVal(s:string): Integer;
var
  i,j: Integer;
  i1, i2: Integer;
begin
  if Length(s) < 2 then
  begin
    Result := 0;
    Exit;
  end;

  {$IFDEF ZEROSTRINGINDEX}
  i1 := 0;
  i2 := 1;
  {$ELSE}
  i1 := 1;
  i2 := 2;
  {$ENDIF}

  if s[i1] >= 'A' then
    i := ord(s[i1]) - ord('A') + 10
  else
    i := ord(s[i1]) - ord('0');

  if s[i2] >= 'A' then
    j := ord(s[i2]) - ord('A') + 10
  else
    j := ord(s[i2]) - ord('0');

  Result := i shl 4 + j;
end;

{$IFDEF CMNWEBLIB}
var
  r,g,b: Integer;
begin
  r := Hexval(Copy(AHTML,2,2));
  g := Hexval(Copy(AHTML,4,2)) shl 8;
  b := Hexval(Copy(AHTML,6,2)) shl 16;
  Result :=  b + g + r;
{$ENDIF}

{$IFDEF FMXLIB}
const
  Alpha = TTMSWEBPersistenceColor($FF000000);
var
  r,g,b: Integer;
begin
  r := Hexval(Copy(AHTML,2,2)) shl 16;
  g := Hexval(Copy(AHTML,4,2)) shl 8;
  b := Hexval(Copy(AHTML,6,2));
  Result := Alpha or TTMSWEBPersistenceColor(b + g + r);
{$ENDIF}
end;

function ColorToHTMLEx(AColor: TTMSWEBPersistenceColor): string;
const
  HTMLHexColor = '#RRGGBB';
  HexDigit: array[0..$F] of Char = '0123456789ABCDEF';
var
  c: TTMSWEBPersistenceColor;
  i: Integer;
begin
  {$IFDEF ZEROSTRINGINDEX}
  i := 0;
  {$ELSE}
  i := 1;
  {$ENDIF}

  {$IFDEF FMXLIB}
  c := AColor;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  c := ColorToRGB(AColor);
  {$ENDIF}
  Result := HtmlHexColor;
  Result[1 + i] := HexDigit[GetColorRed(c) shr 4];
  Result[2 + i] := HexDigit[GetColorRed(c) and $F];
  Result[3 + i] := HexDigit[GetColorGreen(c) shr 4];
  Result[4 + i] := HexDigit[GetColorGreen(c) and $F];
  Result[5 + i] := HexDigit[GetColorBlue(c) shr 4];
  Result[6 + i] := HexDigit[GetColorBlue(c) and $F];
end;
{$ENDIF}

{$IFDEF FNCLIB}
function DefaultJSONToClassOptions: TTMSWEBJSONToClassOptions;
begin
  Result.AddUnit := False;
  Result.AddImplementation := False;
  Result.AddConstructor := False;
  Result.AddDestructor := False;
  Result.AddAssign := False;
  Result.BaseClass := cbcNone;
  Result.SortProperties := True;
  Result.DelphiCasing := True;
  Result.RemoveSpecialCharacters := True;
end;
{$ENDIF}

{ TTMSWEBWriter }

constructor TTMSWEBWriter.Create(AStream: TStream);
begin
  FWriter := TTMSWEBJSONWriter.Create(AStream);
  FWriterRef := False;
end;

constructor TTMSWEBWriter.Create(AWriter: TTMSWEBJSONWriter);
begin
  FWriter := AWriter;
  FWriterRef := True;
end;

destructor TTMSWEBWriter.Destroy;
begin
  if FWriterRef then
    FWriter := nil
  else
    FWriter.Free;
  inherited;
end;

procedure TTMSWEBWriter.SetExcludeProperties(
  const Value: TTMSWEBExcludePropertyListArray);
begin
  FExcludeProperties := Value;
  TTMSWEBPersistence.ExcludeProperties := FExcludeProperties;
end;

procedure TTMSWEBWriter.SetIOReference(const Value: TObject);
begin
  FIOReference := Value;
  TTMSWEBPersistence.IOReference := FIOReference;
end;

procedure TTMSWEBWriter.SetRootObject(const Value: TObject);
begin
  FRootObject := Value;
  TTMSWEBPersistence.RootObject := FRootObject;
end;

procedure TTMSWEBWriter.WriteGenericStringObjectDictionary(
  ADictionary: TTMSWEBStringObjectDictionary);
var
  {$IFDEF LCLLIB}
  k: Integer;
  key: string;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  key: string;
  {$ENDIF}
begin
  Writer.WriteBeginArray;
  {$IFDEF LCLLIB}
  for k := 0 to ADictionary.Count - 1 do
  begin
    key := ADictionary.Keys[k];
  {$ENDIF}
  {$IFNDEF LCLLIB}
  for key in ADictionary.Keys do
  begin
  {$ENDIF}
    Writer.WriteBeginObject;
    Writer.WriteName(key);
    WriteSingleObject(ADictionary[key]);
    Writer.WriteEndObject;
  end;
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericIntegerObjectDictionary(
  ADictionary: TTMSWEBIntegerObjectDictionary);
var
  {$IFDEF LCLLIB}
  k: Integer;
  key: Integer;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  key: Integer;
  {$ENDIF}
begin
  Writer.WriteBeginArray;
  {$IFDEF LCLLIB}
  for k := 0 to ADictionary.Count - 1 do
  begin
    key := ADictionary.Keys[k];
  {$ENDIF}
  {$IFNDEF LCLLIB}
  for key in ADictionary.Keys do
  begin
  {$ENDIF}
    Writer.WriteBeginObject;
    Writer.WriteName(IntToStr(key));
    WriteSingleObject(ADictionary[key]);
    Writer.WriteEndObject;
  end;
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericIntegerIntegerDictionary(
  ADictionary: TTMSWEBIntegerIntegerDictionary);
var
  {$IFDEF LCLLIB}
  k: Integer;
  key: Integer;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  key: Integer;
  {$ENDIF}
begin
  Writer.WriteBeginArray;
  {$IFDEF LCLLIB}
  for k := 0 to ADictionary.Count - 1 do
  begin
    key := ADictionary.Keys[k];
  {$ENDIF}
  {$IFNDEF LCLLIB}
  for key in ADictionary.Keys do
  begin
  {$ENDIF}
    Writer.WriteBeginObject;
    Writer.WriteName(IntToStr(key));
    Writer.WriteInteger(ADictionary[key]);
    Writer.WriteEndObject;
  end;
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericIntegerBooleanDictionary(
  ADictionary: TTMSWEBIntegerBooleanDictionary);
var
  {$IFDEF LCLLIB}
  k: Integer;
  key: Integer;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  key: Integer;
  {$ENDIF}
begin
  Writer.WriteBeginArray;
  {$IFDEF LCLLIB}
  for k := 0 to ADictionary.Count - 1 do
  begin
    key := ADictionary.Keys[k];
  {$ENDIF}
  {$IFNDEF LCLLIB}
  for key in ADictionary.Keys do
  begin
  {$ENDIF}
    Writer.WriteBeginObject;
    Writer.WriteName(IntToStr(key));
    Writer.WriteBoolean(ADictionary[key]);
    Writer.WriteEndObject;
  end;
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericIntegerDoubleDictionary(
  ADictionary: TTMSWEBIntegerDoubleDictionary);
var
  {$IFDEF LCLLIB}
  k: Integer;
  key: Integer;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  key: Integer;
  {$ENDIF}
begin
  Writer.WriteBeginArray;
  {$IFDEF LCLLIB}
  for k := 0 to ADictionary.Count - 1 do
  begin
    key := ADictionary.Keys[k];
  {$ENDIF}
  {$IFNDEF LCLLIB}
  for key in ADictionary.Keys do
  begin
  {$ENDIF}
    Writer.WriteBeginObject;
    Writer.WriteName(IntToStr(key));
    Writer.WriteDouble(ADictionary[key]);
    Writer.WriteEndObject;
  end;
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericDoubleList(AList: TTMSWEBDoubleList);
var
  I: Integer;
begin
  Writer.WriteBeginArray;
  for I := 0 to AList.Count - 1 do
    Writer.WriteDouble(AList[I]);
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericIntegerList(AList: TTMSWEBIntegerList);
var
  I: Integer;
begin
  Writer.WriteBeginArray;
  for I := 0 to AList.Count - 1 do
    Writer.WriteInteger(AList[I]);
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericObjectList(AList: TTMSWEBObjectList);
var
  I: Integer;
begin
  Writer.WriteBeginArray;
  for I := 0 to AList.Count - 1 do
    WriteSingleObject(AList[I]);
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteGenericStringList(AList: TTMSWEBStringList);
var
  I: Integer;
begin
  Writer.WriteBeginArray;
  for I := 0 to AList.Count - 1 do
    Writer.WriteString(AList[I]);
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.Write(AObject: TObject);
begin
  WriteObject(AObject);
end;

procedure TTMSWEBWriter.WriteArray(AName: string; AArray: TTMSWEBObjectArray);
var
  I: Integer;
begin
  Writer.WriteBeginObject;
  Writer.WriteName(AName);
  Writer.WriteBeginArray;
  for I := 0 to Length(AArray) - 1 do
    WriteSingleObject(AArray[I]);
  Writer.WriteEndArray;
  Writer.WriteEndObject;
end;

{$IFNDEF RTLONLY}
procedure TTMSWEBWriter.WriteBitmap(ABitmap: TTMSWEBBitmap);
{$IFNDEF WEBLIB}
var
  ms: TMemoryStream;
{$ENDIF}
begin
  if IsBitmapEmpty(ABitmap) then
  begin
    FWriter.WriteString('');
    Exit;
  end;

 {$IFNDEF WEBLIB}
  ms := TMemoryStream.Create;
  try
    ABitmap.SaveToStream(ms);
    ms.Position := 0;
    FWriter.WriteString(TTMSWEBUtils.SaveStreamToHexStr(ms));
  finally
    ms.Free;
  end;
  {$ENDIF}
  {$IFDEF WEBLIB}
  FWriter.WriteString(ABitmap.Data);
  {$ENDIF}
end;
{$ENDIF}

procedure TTMSWEBWriter.WriteCollection(ACollection: TCollection);
var
  I: Integer;
begin
  Writer.WriteBeginArray;
  for I := 0 to ACollection.Count - 1 do
    WriteSingleObject(ACollection.Items[I]);
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteList(AList: TList);
var
  I: Integer;
begin
  Writer.WriteBeginArray;
  for I := 0 to AList.Count - 1 do
    WriteSingleObject(TObject(AList[I]));
  Writer.WriteEndArray;
end;

procedure TTMSWEBWriter.WriteObject(AObject: TObject);
var
  b: ITMSWEBPersistenceIO;
begin
  if AObject = nil then
    Writer.WriteNull
  else
  begin
    if TTMSWEBPersistence.IsGenericList(AObject.ClassType, 'String') then
      WriteGenericStringList(TTMSWEBStringList(AObject))
    else if TTMSWEBPersistence.IsGenericList(AObject.ClassType, 'Integer') then
      WriteGenericIntegerList(TTMSWEBIntegerList(AObject))
    else if TTMSWEBPersistence.IsGenericList(AObject.ClassType, 'Double') then
      WriteGenericDoubleList(TTMSWEBDoubleList(AObject))
    else if TTMSWEBPersistence.IsGenericList(AObject.ClassType) then
      WriteGenericObjectList(TTMSWEBObjectList(AObject))
    else if TTMSWEBPersistence.IsGenericStringDictionary(AObject.ClassType) then
    begin
      if TTMSWEBPersistence.IsGenericDictionaryValueTypeObject(AObject.ClassType) then
        WriteGenericStringObjectDictionary(TTMSWEBStringObjectDictionary(AObject))
      else
        Writer.WriteNull;
    end
    else if TTMSWEBPersistence.IsGenericIntegerDictionary(AObject.ClassType) then
    begin
      if TTMSWEBPersistence.IsGenericDictionaryValueTypeObject(AObject.ClassType) then
        WriteGenericIntegerObjectDictionary(TTMSWEBIntegerObjectDictionary(AObject))
      else if TTMSWEBPersistence.IsGenericDictionaryValueTypeInteger(AObject.ClassType) then
        WriteGenericIntegerIntegerDictionary(TTMSWEBIntegerIntegerDictionary(AObject))
      else if TTMSWEBPersistence.IsGenericDictionaryValueTypeBoolean(AObject.ClassType) then
        WriteGenericIntegerBooleanDictionary(TTMSWEBIntegerBooleanDictionary(AObject))
      else if TTMSWEBPersistence.IsGenericDictionaryValueTypeDouble(AObject.ClassType) then
        WriteGenericIntegerDoubleDictionary(TTMSWEBIntegerDoubleDictionary(AObject))
      else
        Writer.WriteNull;
    end
    else if TTMSWEBPersistence.IsList(AObject.ClassType) then
      WriteList(TList(AObject))
    else if TTMSWEBPersistence.IsCollection(AObject.ClassType) then
      WriteCollection(TCollection(AObject))
    {$IFNDEF RTLONLY}
    else if TTMSWEBPersistence.IsBitmap(AObject.ClassType) then
      WriteBitmap(TTMSWEBBitmap(AObject))
    {$ENDIF}
    else if TTMSWEBPersistence.IsDescendingClass(AObject.ClassType, ['TStrings']) then
      WriteStrings(TStrings(AObject))
    else
    begin
      if Assigned(IOReference) and Supports(IOReference, ITMSWEBPersistenceIO, b) then
      begin
        if b.NeedsObjectReference(AObject.ClassType) then
          Writer.WriteString(b.GetObjectReference(AObject))
        else
          WriteSingleObject(AObject);
      end
      else
        WriteSingleObject(AObject);
    end;
  end;
end;

procedure TTMSWEBWriter.WriteSingleObject(AObject: TObject);
begin
  Writer.WriteBeginObject;
  if TTMSWEBPersistence.ClassTypeVariable <> '' then
  begin
    Writer.WriteName(TTMSWEBPersistence.ClassTypeVariable);
    Writer.WriteString(AObject.ClassName);
  end;
  WriteProperties(AObject);
  Writer.WriteEndObject;
end;

procedure TTMSWEBWriter.WriteStrings(AList: TStrings);
var
  I: Integer;
begin
  Writer.WriteBeginArray;
  for I := 0 to AList.Count - 1 do
    Writer.WriteString(AList[I]);
  Writer.WriteEndArray;
end;

{$HINTS OFF}
procedure TTMSWEBWriter.WritePropInfoValue(AInstance: TObject; const APropInfo: TTMSWEBPropertyInfo);
var
  cn: string;
  pName: string;
  en: string;
  k: TTypeKind;
  p: TTMSWEBPropertyInfo;
  o: TObject;
  v: TMethod;
  {$IFNDEF RTLONLY}
  c: TTMSWEBPersistenceColor;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFDEF WEBLIB}
  vr: JSValue;
  {$ELSE}
  vr: Variant;
  {$ENDIF}
  {$ENDIF}
begin
  if TTMSWEBPersistence.IsWriteOnly(APropInfo) then
  begin
    Writer.WriteNull;
    Exit;
  end;

  o := AInstance;
  p := APropInfo;
  k := TTMSWEBPersistence.GetPropInfoType(p);
  pName := TTMSWEBPersistence.GetPropInfoName(p);

  case k of
    tkInteger:
    begin
      cn := TTMSWEBPersistence.GetPropInfoTypeName(p);
      if (cn = 'TAlphaColor') or (cn = 'TColor') or (cn = 'TGraphicsColor') then
      begin
        {$IFNDEF RTLONLY}
        if GetOrdProp(o, p) = gcNull then
          Writer.WriteString('gcNull')
        else
        begin
          c := TTMSWEBPersistenceColor(GetOrdProp(o, p));
          Writer.WriteString(ColorToHTMLEx(c))
        end;
        {$ELSE}
        Writer.WriteNull;
        {$ENDIF}
      end
      else
        Writer.WriteInteger(GetOrdProp(o, p));
    end;
    {$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}: Writer.WriteString(GetStrProp(o, p));
    tkEnumeration:
      if TTMSWEBPersistence.GetPropInfoDataTypeInfo(p) = TypeInfo(Boolean) then
        Writer.WriteBoolean(Boolean(GetOrdProp(o, p)))
      else
        Writer.WriteInteger(GetOrdProp(o, p));
    {$IFDEF LCLLIB}
    tkBool: Writer.WriteBoolean(Boolean(GetOrdProp(o, p)));
    {$ENDIF}
    {$IFDEF WEBLIB}
    tkBool: Writer.WriteBoolean(GetBoolProp(o, p));
    {$ENDIF}
    tkFloat: Writer.WriteDouble(GetFloatProp(o, p));
    {$IFNDEF WEBLIB}
    tkInt64: Writer.WriteInteger(GetInt64Prop(o, p));
    {$ENDIF}
    tkSet: Writer.WriteInteger(GetOrdProp(o, p));
    {$IFNDEF LCLLIB}
    {$IFDEF WEBLIB}
    tkJSValue:
    begin
      vr := GetJSValueProp(o, p);
      if isUndefined(vr) or isNull(vr) then
        Writer.WriteNull
      else if IsNumber(vr) then
      begin
        if Frac(Double(vr))=0 then
          Writer.WriteInteger(NativeInt(vr))
        else
          Writer.WriteDouble(Double(vr))
      end
      else if isBoolean(vr) then
        Writer.WriteBoolean(Boolean(vr))
      else if isString(vr) then
        Writer.WriteString(string(vr))
      else
        Writer.WriteNull;
    end;
    {$ELSE}
    tkVariant:
    begin
      vr := GetVariantProp(o, p);
      case VarType(vr) of
        varEmpty, varNull: Writer.WriteNull;
        varBoolean: Writer.WriteBoolean(TVarData(vr).VBoolean);
        varShortInt: Writer.WriteInteger(TVarData(vr).VShortInt);
        varSmallint: Writer.WriteInteger(TVarData(vr).VSmallInt);
        varInteger:  Writer.WriteInteger(TVarData(vr).VInteger);
        varSingle:  Writer.WriteDouble(TVarData(vr).VSingle);
        varDouble: Writer.WriteDouble(TVarData(vr).VDouble);
        varCurrency: Writer.WriteDouble(TVarData(vr).VCurrency);
        varDate: Writer.WriteDouble(TVarData(vr).VDate);
        varOleStr: Writer.WriteString(string(TVarData(vr).VOleStr));
        varByte: Writer.WriteInteger(TVarData(vr).VByte);
        varWord: Writer.WriteInteger(TVarData(vr).VWord);
        varLongWord: Writer.WriteInteger(TVarData(vr).VLongWord);
        varInt64: Writer.WriteInteger(TVarData(vr).VInt64);
        varUInt64: Writer.WriteInteger(TVarData(vr).VUInt64);
        varString: Writer.WriteString(string(TVarData(vr).VString));
        varUString: Writer.WriteString(UnicodeString(TVarData(vr).VUString));
        else
          Writer.WriteNull;
      end;
    end;
    {$ENDIF}
    {$ENDIF}
    tkMethod:
    begin
      v := GetMethodProp(o, p);
      if v.Code = nil then
        Writer.WriteNull
      else
      begin
        if Assigned(TTMSWEBPersistence.RootObject) then
          Writer.WriteString(TTMSWEBPersistence.RootObject.MethodName(v.Code))
        else
          Writer.WriteNull;
      end;
    end
    else
    begin
      en := TTMSWEBPersistence.GetEnumName(TypeInfo(TTypeKind), Integer(k));
      Writer.WriteNull;
    end;
  end;

  {$IFNDEF RTLONLY}
  if (o is TFont) and (pName = 'Size') then
  begin
    Writer.WriteName('IsFMX');
    Writer.WriteBoolean({$IFDEF FMXLIB}True{$ELSE}False{$ENDIF});
  end;
  {$ENDIF}
end;
{$HINTS ON}

procedure TTMSWEBWriter.WriteProperties(AObject: TObject);
var
  {$IFNDEF WEBLIB}
  ci: Pointer;
  c: Integer;
  pl: PPropList;
  {$ENDIF}
  {$IFDEF WEBLIB}
  ci: TTypeInfoClass;
  a: TTypeMemberPropertyDynArray;
  {$ENDIF}
  I: Integer;
begin
  if Assigned(AObject) then
  begin
    {$IFNDEF WEBLIB}
    ci := AObject.ClassInfo;
    c := GetPropList(ci, tkAny, nil);
    GetMem(pl, c * SizeOf(TTMSWEBPropertyInfo));
    {$ENDIF}
    {$IFDEF WEBLIB}
    ci := TypeInfo(AObject);
    {$ENDIF}
    try
      {$IFNDEF WEBLIB}
      GetPropList(ci, tkAny, pl);
      for I := 0 to c - 1 do
        WriteProperty(AObject, pl^[i]);
      {$ENDIF}
      {$IFDEF WEBLIB}
      a := GetPropList(ci, tkAny);
      for I := 0 to Length(a) - 1 do
        WriteProperty(AObject, a[I]);
      {$ENDIF}
    finally
      {$IFNDEF WEBLIB}
      FreeMem(pl);
      {$ENDIF}
    end;
  end;
end;

procedure TTMSWEBWriter.WriteProperty(AObject: TObject; AProp: TTMSWEBPropertyInfo);
var
  pName: string;
  k: TTypeKind;
  b, a, ap: Boolean;
  p: ITMSWEBPersistence;
  crw: ITMSWEBCustomReadWriteIO;
  o: TObject;
begin
  if not Assigned(AProp) then
    Exit;

  pName := TTMSWEBPersistence.GetPropInfoName(AProp);
  k := TTMSWEBPersistence.GetPropInfoType(AProp);

  b := TTMSWEBUtils.IndexOfTextInArray(pName, TTMSWEBPersistence.ExcludeProperties) = -1;
  if Supports(AObject, ITMSWEBPersistence, p) then
    b := p.CanSaveProperty(AObject, pName, k);

  if b then
  begin
    a := True;
    if Assigned(OnCustomWriteProperty) then
      OnCustomWriteProperty(AObject, pName, k, Writer, a);

    if a and Supports(AObject, ITMSWEBCustomReadWriteIO, crw) then
      crw.CustomWriteProperty(AObject, pName, k, Writer, a);

    if a then
    begin
      Writer.WriteName(pName);

      if k in [tkClass] then
      begin
        o := GetObjectProp(AObject, pName);

        ap := TTMSWEBPersistence.IsAssignableProperty(AObject, AProp);

        if Assigned(OnCustomIsAssignableProperty) then
          OnCustomIsAssignableProperty(AObject, pName, ap);

        if ap then
        begin
          if o is TComponent then
            Writer.WriteString((o as TComponent).Name)
          else
            Writer.WriteString('');
        end
        else
          WriteObject(o);
      end
      else
        WritePropInfoValue(AObject, AProp);
    end;
  end;
end;

{ TTMSWEBReader }

constructor TTMSWEBReader.Create(AStream: TStream);
begin
  FReader := TTMSWEBJSONReader.Create(AStream);
  FReaderRef := False;
  FReferences := TTMSWEBObjectReferences.Create(true);
end;

constructor TTMSWEBReader.Create(AReader: TTMSWEBJSONReader);
begin
  FReader := AReader;
  FReaderRef := True;
  FReferences := TTMSWEBObjectReferences.Create(true);
end;

destructor TTMSWEBReader.Destroy;
begin
  if FReaderRef then
    FReader := nil
  else
    FReader.Free;

  FReferences.Free;
  inherited;
end;

function TTMSWEBReader.ReadSingleObject(ABaseClass: TClass): TObject;
var
  cn: string;
  b: ITMSWEBBasePersistenceIO;
  p: ITMSWEBPersistenceIO;
begin
  Reader.ReadBeginObject;
  if TTMSWEBPersistence.ClassTypeVariable <> '' then
  begin
    if not Reader.HasNext or (Reader.ReadName <> TTMSWEBPersistence.ClassTypeVariable) then
      raise ETMSWEBReaderException.Create('"'+TTMSWEBPersistence.ClassTypeVariable+'" property not found in Object descriptor.');

    cn := Reader.ReadString;
  end;

  if cn = '' then
    cn := ABaseClass.ClassName;

  Result := nil;

  if Assigned(FIOReference) then
  begin
    if Supports(FIOReference, ITMSWEBBasePersistenceIO, b) then
      Result := b.CreateObject(cn, ABaseClass)
    else if Supports(FIOReference, ITMSWEBPersistenceIO, p) then
      Result := p.CreateObject(cn, ABaseClass);
  end;

  if not Assigned(Result) then
    Result := TTMSWEBPersistence.CreateObject(cn, ABaseClass);
    
  try
    ReadProperties(Result);
    Reader.ReadEndObject;
  except
    Result.Free;
    raise;
  end;
end;

procedure TTMSWEBReader.ReadExistingObject(AObject: TObject);
begin
  if Assigned(AObject) then
  begin
    if not Reader.IsNull then
    begin
      Reader.ReadBeginObject;
      if TTMSWEBPersistence.ClassTypeVariable <> '' then
      begin
        if not Reader.HasNext or (Reader.ReadName <> TTMSWEBPersistence.ClassTypeVariable) then
          raise ETMSWEBReaderException.Create('"'+TTMSWEBPersistence.ClassTypeVariable+'" property not found in Object descriptor.');

        Reader.ReadString;
      end;

      ReadProperties(AObject);
      Reader.ReadEndObject;
    end
    else
      Reader.SkipValue;
  end
  else
    Reader.ReadNull;
end;

procedure TTMSWEBReader.ReadGenericStringObjectDictionary(ADictionary: TTMSWEBStringObjectDictionary);
var
  obj: TObject;
  k: string;
  c: TClass;
  i: ITMSWEBBaseListIO;
  cl: Boolean;
begin
  if Supports(ADictionary, ITMSWEBBaseListIO, i) then
    c := i.GetItemClass
  else
    c := TTMSWEBPersistence.GetGenericDictionaryValueType(ADictionary.ClassType);

  cl := False;
  ADictionary.Clear;
  Reader.ReadBeginArray;
  if not Reader.HasNext then
    ADictionary.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        Reader.ReadBeginObject;
        k := Reader.ReadName;
        obj := ReadSingleObject(c);
        if Assigned(obj) then
        begin
          if not cl then
          begin
            ADictionary.Clear;
            cl := True;
          end;

          ADictionary.Add(k, obj);
        end;
        Reader.ReadEndObject;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericIntegerObjectDictionary(ADictionary: TTMSWEBIntegerObjectDictionary);
var
  obj: TObject;
  k: Integer;
  c: TClass;
  i: ITMSWEBBaseListIO;
  cl: Boolean;
begin
  if Supports(ADictionary, ITMSWEBBaseListIO, i) then
    c := i.GetItemClass
  else
    c := TTMSWEBPersistence.GetGenericDictionaryValueType(ADictionary.ClassType);

  cl := False;
  ADictionary.Clear;
  Reader.ReadBeginArray;
  if not Reader.HasNext then
    ADictionary.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        Reader.ReadBeginObject;
        TryStrToInt(Reader.ReadName, k);
        obj := ReadSingleObject(c);
        if Assigned(obj) then
        begin
          if not cl then
          begin
            ADictionary.Clear;
            cl := True;
          end;

          ADictionary.Add(k, obj);
        end;
        Reader.ReadEndObject;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericIntegerDoubleDictionary(ADictionary: TTMSWEBIntegerDoubleDictionary);
var
  obj: Double;
  k: Integer;
  cl: Boolean;
begin
  cl := False;
  ADictionary.Clear;
  Reader.ReadBeginArray;
  if not Reader.HasNext then
    ADictionary.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        Reader.ReadBeginObject;
        TryStrToInt(Reader.ReadName, k);
        obj := Reader.ReadDouble;
        if not cl then
        begin
          ADictionary.Clear;
          cl := True;
        end;

        ADictionary.Add(k, obj);
        Reader.ReadEndObject;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericIntegerBooleanDictionary(ADictionary: TTMSWEBIntegerBooleanDictionary);
var
  obj: Boolean;
  k: Integer;
  cl: Boolean;
begin
  cl := False;
  ADictionary.Clear;
  Reader.ReadBeginArray;
  if not Reader.HasNext then
    ADictionary.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        Reader.ReadBeginObject;
        TryStrToInt(Reader.ReadName, k);
        obj := Reader.ReadBoolean;
        if not cl then
        begin
          ADictionary.Clear;
          cl := True;
        end;

        ADictionary.Add(k, obj);
        Reader.ReadEndObject;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericIntegerIntegerDictionary(ADictionary: TTMSWEBIntegerIntegerDictionary);
var
  obj: Integer;
  k: Integer;
  cl: Boolean;
begin
  cl := False;
  ADictionary.Clear;
  Reader.ReadBeginArray;
  if not Reader.HasNext then
    ADictionary.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        Reader.ReadBeginObject;
        TryStrToInt(Reader.ReadName, k);
        obj := Reader.ReadInteger;
        if not cl then
        begin
          ADictionary.Clear;
          cl := True;
        end;

        ADictionary.Add(k, obj);
        Reader.ReadEndObject;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericStringList(AList: TTMSWEBStringList);
var
  obj: string;
begin
  AList.Clear;
  Reader.ReadBeginArray;
  while Reader.HasNext do
  begin
    if not Reader.IsNull then
    begin
      obj := Reader.ReadString;
      AList.Add(obj);
    end
    else
      Reader.SkipValue;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericIntegerList(AList: TTMSWEBIntegerList);
var
  obj: Integer;
begin
  AList.Clear;
  Reader.ReadBeginArray;
  while Reader.HasNext do
  begin
    if not Reader.IsNull then
    begin
      obj := Reader.ReadInteger;
      AList.Add(obj);
    end
    else
      Reader.SkipValue;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericDoubleList(AList: TTMSWEBDoubleList);
var
  obj: Double;
begin
  AList.Clear;
  Reader.ReadBeginArray;
  while Reader.HasNext do
  begin
    if not Reader.IsNull then
    begin
      obj := Reader.ReadDouble;
      AList.Add(obj);
    end
    else
      Reader.SkipValue;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadGenericObjectList(AList: TTMSWEBObjectList);
var
  obj: TObject;
  b: ITMSWEBPersistenceIO;
  c: TClass;
  i: ITMSWEBBaseListIO;
  cl: Boolean;
begin
  if Supports(AList, ITMSWEBBaseListIO, i) then
    c := i.GetItemClass
  else
    c := TTMSWEBPersistence.GetGenericListType(AList.ClassType);

  cl := False;
  Reader.ReadBeginArray;
  if not Reader.HasNext then
    AList.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        obj := ReadSingleObject(c);
        if Assigned(obj) then
        begin
          if not cl then
          begin
            AList.Clear;
            cl := True;
          end;

          if Assigned(IOReference) and Supports(IOReference, ITMSWEBPersistenceIO, b) then
            b.FixOwners(obj, AList);

          AList.Add(obj);
        end;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

function TTMSWEBReader.Read(AClass: TClass): TObject;
begin
  Result := ReadSingleObject(AClass);
end;

procedure TTMSWEBReader.Read(AObject: TObject);
begin
  ReadObject(AObject);
end;

{$IFNDEF RTLONLY}
procedure TTMSWEBReader.ReadBitmap(ABitmap: TTMSWEBBitmap);
var
  s: string;
  {$IFNDEF WEBLIB}
  ms: TMemoryStream;
  {$ENDIF}
begin
  if Reader.IsNull then
    Exit;

  s := Reader.ReadString;
  if s <> '' then
  begin
    {$IFNDEF WEBLIB}
    ms := TMemoryStream.Create;
    try
      TTMSWEBUtils.LoadStreamFromHexStr(s, ms);
      ms.Position := 0;
      ABitmap.LoadFromStream(ms);
    finally
      ms.Free;
    end;
    {$ELSE}
    ABitmap.Data := s;
    {$ENDIF}
  end;
end;
{$ENDIF}

procedure TTMSWEBReader.ReadCollection(ACollection: TCollection);
var
  obj: TObject;
  c: TClass;
  i: ITMSWEBBaseListIO;
  ii: ITMSWEBBaseCollectionIO;
  cl: Boolean;
begin
  if Supports(ACollection, ITMSWEBBaseListIO, i) then
    c := i.GetItemClass
  else
    c := ACollection.ItemClass;

  Supports(ACollection, ITMSWEBBaseCollectionIO, ii);

  cl := False;

  Reader.ReadBeginArray;
  if not Reader.HasNext then
    ACollection.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        obj := ReadSingleObject(c);
        if Assigned(obj) then
        begin
          if not cl then
          begin
            ACollection.Clear;
            cl := True;
          end;

          try
            if obj is TPersistent then
            begin
              if Assigned(ii) then
                ii.AddItem(obj).Assign(obj as TPersistent)
              else
                ACollection.Add.Assign(obj as TPersistent);
            end;
          finally
            obj.Free;
          end;
        end;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

function TTMSWEBReader.ReadArray(AName: string): TTMSWEBObjectArray;
var
  Name: string;
begin
  Reader.ReadBeginObject;
  while Reader.HasNext do
  begin
    if not Reader.IsNull then
    begin
      Name := Reader.ReadName;
      if Name = AName then
      begin
        Reader.ReadBeginArray;
        while Reader.HasNext do
        begin
          SetLength(Result, Length(Result) + 1);
          Result[Length(Result) - 1] := ReadSingleObject(TObject);
        end;
        Reader.ReadEndArray;
      end
      else
        Reader.SkipValue;
    end
    else
      Reader.SkipValue;
  end;
end;

procedure TTMSWEBReader.ReadList(AList: TList);
var
  obj: TObject;
  b: ITMSWEBPersistenceIO;
  c: TClass;
  i: ITMSWEBBaseListIO;
  cl: Boolean;
begin
  c := TObject;
  if Supports(AList, ITMSWEBBaseListIO, i) then
    c := i.GetItemClass;

  cl := False;

  Reader.ReadBeginArray;
  if not Reader.HasNext then
    AList.Clear
  else
  begin
    while Reader.HasNext do
    begin
      if not Reader.IsNull then
      begin
        obj := ReadSingleObject(c);
        if Assigned(obj) then
        begin
          if not cl then
          begin
            AList.Clear;
            cl := True;
          end;

          if Assigned(IOReference) and Supports(IOReference, ITMSWEBPersistenceIO, b) then
            b.FixOwners(obj, AList);
          AList.Add(obj);
        end;
      end
      else
        Reader.SkipValue;
    end;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.ReadObject(AObject: TObject);
begin
  if AObject = nil then
    Reader.ReadNull
  else
  begin
    if TTMSWEBPersistence.IsGenericList(AObject.ClassType, 'String') then
      ReadGenericStringList(TTMSWEBStringList(AObject))
    else if TTMSWEBPersistence.IsGenericList(AObject.ClassType, 'Double') then
      ReadGenericDoubleList(TTMSWEBDoubleList(AObject))
    else if TTMSWEBPersistence.IsGenericList(AObject.ClassType, 'Integer') then
      ReadGenericIntegerList(TTMSWEBIntegerList(AObject))
    else if TTMSWEBPersistence.IsGenericList(AObject.ClassType) then
      ReadGenericObjectList(TTMSWEBObjectList(AObject))
    else if TTMSWEBPersistence.IsGenericStringDictionary(AObject.ClassType) then
    begin
      if TTMSWEBPersistence.IsGenericDictionaryValueTypeObject(AObject.ClassType) then
        ReadGenericStringObjectDictionary(TTMSWEBStringObjectDictionary(AObject))
      else
        Reader.ReadNull
    end
    else if TTMSWEBPersistence.IsGenericIntegerDictionary(AObject.ClassType) then
    begin
      if TTMSWEBPersistence.IsGenericDictionaryValueTypeObject(AObject.ClassType) then
        ReadGenericIntegerObjectDictionary(TTMSWEBIntegerObjectDictionary(AObject))
      else if TTMSWEBPersistence.IsGenericDictionaryValueTypeInteger(AObject.ClassType) then
        ReadGenericIntegerIntegerDictionary(TTMSWEBIntegerIntegerDictionary(AObject))
      else if TTMSWEBPersistence.IsGenericDictionaryValueTypeBoolean(AObject.ClassType) then
        ReadGenericIntegerBooleanDictionary(TTMSWEBIntegerBooleanDictionary(AObject))
      else if TTMSWEBPersistence.IsGenericDictionaryValueTypeDouble(AObject.ClassType) then
        ReadGenericIntegerDoubleDictionary(TTMSWEBIntegerDoubleDictionary(AObject))
      else
        Reader.ReadNull;
    end
    else if TTMSWEBPersistence.IsList(AObject.ClassType) then
      ReadList(TList(AObject))
    else if TTMSWEBPersistence.IsCollection(AObject.ClassType) then
      ReadCollection(TCollection(AObject))
    {$IFNDEF RTLONLY}
    else if TTMSWEBPersistence.IsBitmap(AObject.ClassType) then
      ReadBitmap(TTMSWEBBitmap(AObject))
    {$ENDIF}
    else if TTMSWEBPersistence.IsDescendingClass(AObject.ClassType, ['TStrings']) then
      ReadStrings(TStrings(AObject))
    else
      ReadSingleObject(AObject);
  end;
end;

procedure TTMSWEBReader.ReadProperties(AObject: TObject);
var
  Prop: TTMSWEBPropertyInfo;
begin
  while Reader.HasNext do
  begin
    if not Reader.IsNull then
    begin
      Prop := nil;
      if Assigned(AObject) then
        Prop := GetPropInfo(AObject, Reader.ReadName);
      if Assigned(Prop) then
        ReadProperty(AObject, Prop)
      else
        Reader.SkipValue;
    end
    else
      Reader.SkipValue;
  end;
end;

procedure TTMSWEBReader.ReadProperty(AObject: TObject; AProp: TTMSWEBPropertyInfo);
var
  pName: string;
  ct: TClass;
  b: Boolean;
  p: ITMSWEBPersistence;
  pio: ITMSWEBPersistenceIO;
  k: TTypeKind;
  a, ap: Boolean;
  o: TObject;
  n: string;
  crw: ITMSWEBCustomReadWriteIO;
begin
  if not Assigned(AProp) then
    Exit;

  k := TTMSWEBPersistence.GetPropInfoType(AProp);
  pName := TTMSWEBPersistence.GetPropInfoName(AProp);

  b := TTMSWEBUtils.IndexOfTextInArray(pName, TTMSWEBPersistence.ExcludeProperties) = -1;
  if Supports(AObject, ITMSWEBPersistence, p) then
    b := p.CanLoadProperty(AObject, pName, k);

  if b then
  begin
    a := True;
    if Assigned(OnCustomReadProperty) then
      OnCustomReadProperty(AObject, pName, k, Reader, a);

    if a and Supports(AObject, ITMSWEBCustomReadWriteIO, crw) then
      crw.CustomReadProperty(AObject, pName, k, Reader, a);

    if a then
    begin
      if k in [tkClass] then
      begin
        ct := TTMSWEBPersistence.GetPropInfoDataTypeInfoClassType(AProp);
        if TTMSWEBPersistence.IsGenericList(ct, 'String') then
          ReadGenericStringList(TTMSWEBStringList(GetObjectProp(AObject, pName)))
        else if TTMSWEBPersistence.IsGenericList(ct, 'Double') then
          ReadGenericDoubleList(TTMSWEBDoubleList(GetObjectProp(AObject, pName)))
        else if TTMSWEBPersistence.IsGenericList(ct, 'Integer') then
          ReadGenericIntegerList(TTMSWEBIntegerList(GetObjectProp(AObject, pName)))
        else if TTMSWEBPersistence.IsGenericList(ct) then
          ReadGenericObjectList(TTMSWEBObjectList(GetObjectProp(AObject, pName)))
        else if TTMSWEBPersistence.IsGenericStringDictionary(ct) then
        begin
          if TTMSWEBPersistence.IsGenericDictionaryValueTypeObject(ct) then
            ReadGenericStringObjectDictionary(TTMSWEBStringObjectDictionary(GetObjectProp(AObject, pName)))
          else
            Reader.SkipValue;
        end
        else if TTMSWEBPersistence.IsGenericIntegerDictionary(ct) then
        begin
          if TTMSWEBPersistence.IsGenericDictionaryValueTypeObject(ct) then
            ReadGenericIntegerObjectDictionary(TTMSWEBIntegerObjectDictionary(GetObjectProp(AObject, pName)))
          else if TTMSWEBPersistence.IsGenericDictionaryValueTypeInteger(ct) then
            ReadGenericIntegerIntegerDictionary(TTMSWEBIntegerIntegerDictionary(GetObjectProp(AObject, pName)))
          else if TTMSWEBPersistence.IsGenericDictionaryValueTypeBoolean(ct) then
            ReadGenericIntegerBooleanDictionary(TTMSWEBIntegerBooleanDictionary(GetObjectProp(AObject, pName)))
          else if TTMSWEBPersistence.IsGenericDictionaryValueTypeDouble(ct) then
            ReadGenericIntegerDoubleDictionary(TTMSWEBIntegerDoubleDictionary(GetObjectProp(AObject, pName)))
          else
            Reader.SkipValue;
        end
        else if TTMSWEBPersistence.IsList(ct) then
          ReadList(TList(GetObjectProp(AObject, pName)))
        else if TTMSWEBPersistence.IsCollection(ct) then
          ReadCollection(TCollection(GetObjectProp(AObject, pName)))
        {$IFNDEF RTLONLY}
        else if TTMSWEBPersistence.IsBitmap(ct) then
          ReadBitmap(TTMSWEBBitmap(GetObjectProp(AObject, pName)))
        {$ENDIF}
        else if TTMSWEBPersistence.IsDescendingClass(ct, ['TStrings']) then
          ReadStrings(TStrings(GetObjectProp(AObject, pName)))
        else
        begin
          a := False;
          if Assigned(IOReference) and Supports(IOReference, ITMSWEBPersistenceIO, pio) then
            a := pio.NeedsObjectReference(ct);

          if a then
          begin
            if Reader.IsNull then
            begin
              Reader.ReadNull;
              SetObjectProp(AObject, pName, nil);
            end
            else
              FReferences.Add(TTMSWEBObjectReference.Create(AObject, AProp, Reader.ReadString));
          end
          else
          begin
            o := GetObjectProp(AObject, pName);

            ap := TTMSWEBPersistence.IsAssignableProperty(AObject, AProp);
            if Assigned(OnCustomIsAssignableProperty) then
              OnCustomIsAssignableProperty(AObject, pName, ap);

            if ap then
            begin
              n := Reader.ReadString;
              if Assigned(FRootObject) and (FRootObject is TComponent) then
                SetObjectProp(AObject, pName, (FRootObject as TComponent).FindComponent(n));
            end
            else
              ReadExistingObject(o);
          end;
        end;
      end
      else
        ReadPropInfoValue(AObject, AProp);
    end;
  end
  else
    Reader.SkipValue;
end;

{$HINTS OFF}
procedure TTMSWEBReader.ReadPropInfoValue(AInstance: TObject; const APropInfo: TTMSWEBPropertyInfo);
var
  pName, cn, cnv, en: string;
  k: TTypeKind;
  p: TTMSWEBPropertyInfo;
  o: TObject;
  i: Integer;
  s: string;
  b: Boolean;
  d: Double;
  ii: Int64;
  v: string;
  m: TMethod;
  bsz: Boolean;
  {$IFNDEF LCLLIB}
  {$IFDEF WEBLIB}
  vr: JSValue;
  {$ELSE}
  vr: Variant;
  {$ENDIF}
  {$ENDIF}
begin
  if TTMSWEBPersistence.IsWriteOnly(APropInfo) or Reader.IsNull then
  begin
    Reader.ReadNull;        
    Exit;
  end;
 
  o := AInstance;
  p := APropInfo;
  pName := TTMSWEBPersistence.GetPropInfoName(p);
  k := TTMSWEBPersistence.GetPropInfoType(p);

  case k of
    tkInteger:
    begin
      cn := TTMSWEBPersistence.GetPropInfoTypeName(p);
      if (cn = 'TAlphaColor') or (cn = 'TColor') or (cn = 'TGraphicsColor') then
      begin
        {$IFNDEF RTLONLY}
        cnv := Reader.ReadString;
        if not TTMSWEBPersistence.IsReadOnly(p) then
        begin
          if cnv = 'gcNull' then
            SetOrdProp(o, pName, gcNull)
          else
          begin
            {$RANGECHECKS OFF}
            SetOrdProp(o, pName, HTMLToColorEx(cnv));
            {$RANGECHECKS ON}
          end;
        end;
        {$ELSE}
        Reader.ReadNull;
        {$ENDIF}
      end
      else
      begin
        i := Reader.ReadInteger;
        if not TTMSWEBPersistence.IsReadOnly(p) then
          SetOrdProp(o, p, i);
      end;
    end;
    {$IFNDEF WEBLIB}tkWChar, tkLString, tkUString,{$ENDIF}tkChar, tkString{$IFDEF LCLLIB},tkAString{$ENDIF}: 
    begin
      s := Reader.ReadString;
      if not TTMSWEBPersistence.IsReadOnly(p) then
        SetStrProp(o, p, s);
    end;
    tkEnumeration:
      if TTMSWEBPersistence.GetPropInfoDataTypeInfo(p) = TypeInfo(Boolean) then
      begin
        b := Reader.ReadBoolean;
        if not TTMSWEBPersistence.IsReadOnly(p) then        
          SetOrdProp(o, p, Integer(b))
      end
      else
      begin
        i := Reader.ReadInteger;
        if not TTMSWEBPersistence.IsReadOnly(p) then
          SetOrdProp(o, p, i);
      end;
    {$IFDEF LCLWEBLIB}
    tkBool:
    begin
      b := Reader.ReadBoolean;
      if not TTMSWEBPersistence.IsReadOnly(p) then
      begin
        {$IFDEF LCLLIB}
        SetOrdProp(o, p, Integer(b))
        {$ELSE}
        SetBoolProp(o, p, b)
        {$ENDIF}
      end;
    end;
    {$ENDIF}
    tkFloat:
    begin
      d := Reader.ReadDouble;
      if not TTMSWEBPersistence.IsReadOnly(p) then
        SetFloatProp(o, p, d)
    end;
    {$IFNDEF WEBLIB}
    tkInt64:
    begin
      ii := Reader.ReadInt64;
      if not TTMSWEBPersistence.IsReadOnly(p) then
        SetOrdProp(o, p, ii)
    end;
    {$ENDIF}
    tkSet:
    begin
      i := Reader.ReadInteger;
      if not TTMSWEBPersistence.IsReadOnly(p) then
        SetOrdProp(o, p, i);
    end;
    {$IFNDEF LCLLIB}
    {$IFDEF WEBLIB}tkJSValue{$ELSE}tkVariant{$ENDIF}:
    begin
      {$IFDEF WEBLIB}
      vr := nil;
      {$ELSE}
      vr := varEmpty;
      {$ENDIF}

      if Reader.HasDouble then
        vr := Reader.ReadDouble
      else if Reader.HasInt64 then
        vr := Reader.ReadInt64
      else if Reader.HasBoolean then
        vr := Reader.ReadBoolean
      else if Reader.HasString then
        vr := Reader.ReadString
      else
        Reader.ReadNull;

      if not TTMSWEBPersistence.IsReadOnly(p) then
      begin
        {$IFDEF WEBLIB}
        SetJSValueProp(o, p, vr);
        {$ELSE}
        SetVariantProp(o, p, vr);
        {$ENDIF}
      end;
    end;
    {$ENDIF}
    tkMethod:
    begin
      m.Data := nil;
      m.Code := nil;
      if Reader.IsNull then
        Reader.ReadNull
      else
      begin
        if Assigned(TTMSWEBPersistence.RootObject) then
        begin
          v := Reader.ReadString;
          m.Code := TTMSWEBPersistence.RootObject.MethodAddress(v);
          if m.Code <> nil then
            m.Data := TTMSWEBPersistence.RootObject;
        end
        else
          Reader.ReadNull;
      end;

      SetMethodProp(o, p, m);
    end
    else
    begin
      en := TTMSWEBPersistence.GetEnumName(TypeInfo(TTypeKind), Integer(k));
      Reader.ReadNull;
    end;
  end;

  {$IFNDEF RTLONLY}
  if (o is TFont) and (pName = 'Size') then
  begin
    if Reader.HasNext then
    begin
      s := Reader.PeekName;
      if s = 'IsFMX' then
      begin
        Reader.ReadName;
        bsz := Reader.ReadBoolean;
        if bsz then
        begin
          {$IFNDEF FMXLIB}
          (o as TFont).Size := Round(((o as TFont).Size / 96) * 72);
          {$ENDIF}
        end
        else
        begin
          {$IFDEF FMXLIB}
          (o as TFont).Size := ((o as TFont).Size / 72) * 96;
          {$ENDIF}
        end;
      end;
    end;
  end;
  {$ENDIF}
end;
{$HINTS ON}

procedure TTMSWEBReader.ReadSingleObject(AObject: TObject);
begin
  Reader.ReadBeginObject;
  if TTMSWEBPersistence.ClassTypeVariable <> '' then
  begin
    if not Reader.HasNext or (Reader.ReadName <> TTMSWEBPersistence.ClassTypeVariable) then
      raise ETMSWEBReaderException.Create('"'+TTMSWEBPersistence.ClassTypeVariable+'" property not found in Object descriptor.');
    Reader.ReadString;
  end;

  try
    ReadProperties(AObject);
    Reader.ReadEndObject;
  except
    raise;
  end;
end;

procedure TTMSWEBReader.ReadStrings(AList: TStrings);
var
  obj: string;
begin
  AList.Clear;
  Reader.ReadBeginArray;
  while Reader.HasNext do
  begin
    if not Reader.IsNull then
    begin
      obj := Reader.ReadString;
      AList.Add(obj);
    end
    else
      Reader.SkipValue;
  end;
  Reader.ReadEndArray;
end;

procedure TTMSWEBReader.SetExcludeProperties(
  const Value: TTMSWEBExcludePropertyListArray);
begin
  FExcludeProperties := Value;
  TTMSWEBPersistence.ExcludeProperties := FExcludeProperties;
end;

procedure TTMSWEBReader.SetIOReference(const Value: TObject);
begin
  FIOReference := Value;
  TTMSWEBPersistence.IOReference := FIOReference;
end;

procedure TTMSWEBReader.SetRootObject(const Value: TObject);
begin
  FRootObject := Value;
  TTMSWEBPersistence.RootObject := FRootObject;
end;

procedure TTMSWEBReader.SolveReferences;
var
  b: ITMSWEBPersistenceIO;
  r: Integer;
  rf: TTMSWEBObjectReference;
  o: TObject;
begin
  if Assigned(IOReference) and Supports(IOReference, ITMSWEBPersistenceIO, b) then
  begin
    for r := 0 to FReferences.Count - 1 do
    begin
      rf := FReferences[r];
      o := b.FindObject(rf.Id);
      SetObjectProp(rf.Instance, rf.Prop, o);
    end;
  end;
end;

{ TTMSWEBObjectReference }

constructor TTMSWEBObjectReference.Create(AInstance: TObject;
  AProp: TTMSWEBPropertyInfo; const AId: string);
begin
  Instance := AInstance;
  Prop := AProp;
  Id := AId;
end;

{ TTMSWEBPersistence }

class procedure TTMSWEBPersistence.LoadSettingsFromFile(AObject: TObject; AFileName: string);
var
  ms: TMemoryStream;
begin
  ms := TMemoryStream.Create;
  {$IFNDEF WEBLIB}
  try
    ms.LoadFromFile(AFileName);
    LoadSettingsFromStream(AObject, ms);
  finally
    ms.Free;
  end;
  {$ELSE}
  try
    ms.LoadFromFile(AFileName,
    procedure
    begin
      LoadSettingsFromStream(AObject, ms);
      ms.Free;
    end
    );
  finally
  end;
  {$ENDIF}
end;

class procedure TTMSWEBPersistence.LoadSettingsFromStream(AObject: TObject; AStream: TStream);
var
  Reader: TTMSWEBReader;
begin
  AStream.Position := 0;
  Reader := TTMSWEBReader.Create(AStream);
  try
    Reader.IOReference := TTMSWEBPersistence.IOReference;
    Reader.RootObject := TTMSWEBPersistence.RootObject;
    Reader.OnCustomReadProperty := DoCustomReadProperty;
    Reader.Read(AObject);
  finally
    Reader.Free;
  end;
end;

class procedure TTMSWEBPersistence.SaveSettingsToFile(AObject: TObject;
  AFileName: string);
var
  ms: TMemoryStream;
begin
  ms := TMemoryStream.Create;
  try
    SaveSettingsToStream(AObject, ms);
    ms.SaveToFile(AFileName);
  finally
    ms.Free;
  end;
end;

class procedure TTMSWEBPersistence.SaveSettingsToStream(AObject: TObject;
  AStream: TStream);
var
  Writer: TTMSWEBWriter;
begin
  Writer := TTMSWEBWriter.Create(AStream);
  try
    Writer.IOReference := TTMSWEBPersistence.IOReference;
    Writer.RootObject := TTMSWEBPersistence.RootObject;
    Writer.OnCustomWriteProperty := DoCustomWriteProperty;
    Writer.Write(AObject);
  finally
    Writer.Free;
  end;
end;

{$HINTS OFF}
class procedure TTMSWEBPersistence.GetEnumValues(AValues: TStrings; APropInfo: TTMSWEBPropertyInfo);
var
  p: PTypeInfo;
  {$IFNDEF WEBLIB}
  su: PTypeData;
  {$IFNDEF LCLLIB}
  ct: PPTypeInfo;
  {$ENDIF}
  {$IFDEF LCLLIB}
  ct: PTypeInfo;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF WEBLIB}
  pi: TTypeInfoInteger;
  ps: PTypeInfo;
  {$ENDIF}
  I: Integer;
  k: TTypeKind;
begin
  p := GetTypeInfoEx(APropInfo);
  {$IFNDEF WEBLIB}
  su := GetTypeData(p);
  if Assigned(su) then
  begin
    if p{$IFDEF LCLLIB}^{$ENDIF}.Kind = tkSet then
    begin
      ct := su^.CompType;
      if Assigned(ct) then
      begin
        k := ct^.Kind;
        case k of
          tkEnumeration:
          begin
            su := GetTypeData(ct{$IFNDEF LCLLIB}^{$ENDIF});
            for i := su^.MinValue to su^.MaxValue do
              AValues.Add(TTMSWEBPersistence.GetEnumName(ct{$IFNDEF LCLLIB}^{$ENDIF},i));
          end;
        end;
      end;
    end
    else
    begin
      for i := su^.MinValue to su^.MaxValue do
        AValues.Add(TTMSWEBPersistence.GetEnumName(p,i));
    end;
  end;
  {$ENDIF}
  {$IFDEF WEBLIB}
  if Assigned(p) and (p is TTypeInfoSet) then
    p := TTypeInfoSet(p).comptype;

  if Assigned(p) and (p is TTypeInfoInteger) then
  begin
   pi := TTypeInfoInteger(p);
   for i := pi.MinValue to pi.MaxValue do
     AValues.Add(TTMSWEBPersistence.GetEnumName(p, i));
  end;
  {$ENDIF}
end;

class function TTMSWEBPersistence.GetGenericDictionaryValueType(
  AClass: TClass): TClass;
var
  cn: string;
  po, pc, poc: Integer;
  fn: string;
  sl: TStringList;
  c, I: Integer;
  p: TPersistentClass;
begin
  if not Assigned(AClass) then
    Exit(TClass(TObject));
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<', cn) or AnsiStartsStr('TObjectDictionary<', cn) then
    begin
      po := Pos('<', cn);
      pc := Pos('>', cn);
      if (po > 0) and (pc > 0) then
      begin
        fn := Copy(cn, po+1, pc - po - 1);
        poc := Pos(',', fn);

        if poc > 0 then
        begin
          fn := Copy(fn, poc + 1, Length(fn) - poc);
          sl := TStringList.Create;
          try
            sl.Delimiter := '.';
            sl.DelimitedText := fn;

            while sl.Count > 0 do
            begin
              fn := sl.DelimitedText;
              p := GetClass(fn);
              if Assigned(p) then
                Exit(p);

              sl.Delete(0);
            end;

          finally
            sl.Free;
          end;
        end;
      end;
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := TClass(TObject);
end;

class function TTMSWEBPersistence.IsGenericDictionaryValueTypeBoolean(
  AClass: TClass): Boolean;
var
  cn: string;
  po, pc, poc: Integer;
  fn: string;
  sl: TStringList;
  c, I: Integer;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<', cn) or AnsiStartsStr('TObjectDictionary<', cn) then
    begin
      po := Pos('<', cn);
      pc := Pos('>', cn);
      if (po > 0) and (pc > 0) then
      begin
        fn := Copy(cn, po+1, pc - po - 1);
        poc := Pos(',', fn);

        if poc > 0 then
        begin
          fn := Copy(fn, poc + 1, Length(fn) - poc);
          sl := TStringList.Create;
          try
            sl.Delimiter := '.';
            sl.DelimitedText := fn;

            while sl.Count > 0 do
            begin
              fn := sl.DelimitedText;
              if (UpperCase(fn) = 'BOOLEAN') or (UpperCase(fn) = 'SYSTEM.BOOLEAN') then
                Exit(True);

              sl.Delete(0);
            end;

          finally
            sl.Free;
          end;
        end;
      end;
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.IsGenericDictionaryValueTypeDouble(
  AClass: TClass): Boolean;
var
  cn: string;
  po, pc, poc: Integer;
  fn: string;
  sl: TStringList;
  c, I: Integer;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<', cn) or AnsiStartsStr('TObjectDictionary<', cn) then
    begin
      po := Pos('<', cn);
      pc := Pos('>', cn);
      if (po > 0) and (pc > 0) then
      begin
        fn := Copy(cn, po+1, pc - po - 1);
        poc := Pos(',', fn);

        if poc > 0 then
        begin
          fn := Copy(fn, poc + 1, Length(fn) - poc);
          sl := TStringList.Create;
          try
            sl.Delimiter := '.';
            sl.DelimitedText := fn;

            while sl.Count > 0 do
            begin
              fn := sl.DelimitedText;
              if (UpperCase(fn) = 'DOUBLE') or (UpperCase(fn) = 'SYSTEM.DOUBLE') then
                Exit(True);

              sl.Delete(0);
            end;

          finally
            sl.Free;
          end;
        end;
      end;
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.IsGenericDictionaryValueTypeInteger(
  AClass: TClass): Boolean;
var
  cn: string;
  po, pc, poc: Integer;
  fn: string;
  sl: TStringList;
  c, I: Integer;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<', cn) or AnsiStartsStr('TObjectDictionary<', cn) then
    begin
      po := Pos('<', cn);
      pc := Pos('>', cn);
      if (po > 0) and (pc > 0) then
      begin
        fn := Copy(cn, po+1, pc - po - 1);
        poc := Pos(',', fn);

        if poc > 0 then
        begin
          fn := Copy(fn, poc + 1, Length(fn) - poc);
          sl := TStringList.Create;
          try
            sl.Delimiter := '.';
            sl.DelimitedText := fn;

            while sl.Count > 0 do
            begin
              fn := sl.DelimitedText;
              if (UpperCase(fn) = 'INTEGER') or (UpperCase(fn) = 'SYSTEM.INTEGER')
                or (UpperCase(fn) = 'LONGINT') or (UpperCase(fn) = 'SYSTEM.LONGINT') then
                  Exit(True);

              sl.Delete(0);
            end;

          finally
            sl.Free;
          end;
        end;
      end;
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.IsGenericDictionaryValueTypeObject(
  AClass: TClass): Boolean;
var
  cn: string;
  po, pc, poc: Integer;
  fn: string;
  sl: TStringList;
  c, I: Integer;
  p: TPersistentClass;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<', cn) or AnsiStartsStr('TObjectDictionary<', cn) then
    begin
      po := Pos('<', cn);
      pc := Pos('>', cn);
      if (po > 0) and (pc > 0) then
      begin
        fn := Copy(cn, po+1, pc - po - 1);
        poc := Pos(',', fn);

        if poc > 0 then
        begin
          fn := Copy(fn, poc + 1, Length(fn) - poc);
          sl := TStringList.Create;
          try
            sl.Delimiter := '.';
            sl.DelimitedText := fn;

            while sl.Count > 0 do
            begin
              fn := sl.DelimitedText;
              p := GetClass(fn);
              if Assigned(p) then
                Exit(True);

              sl.Delete(0);
            end;

          finally
            sl.Free;
          end;
        end;
      end;
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.GetGenericListType(AClass: TClass): TClass;
var
  cn: string;
  po, pc: Integer;
  fn: string;
  sl: TStringList;
  c, I: Integer;
  p: TPersistentClass;
begin
  if not Assigned(AClass) then
    Exit(TClass(TObject));
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TList<', cn) or AnsiStartsStr('TObjectList<', cn) then
    begin
      po := Pos('<', cn);
      pc := Pos('>', cn);
      if (po > 0) and (pc > 0) then
      begin
        fn := Copy(cn, po+1, pc - po - 1);

        sl := TStringList.Create;
        try
          sl.Delimiter := '.';
          sl.DelimitedText := fn;

          while sl.Count > 0 do
          begin
            fn := sl.DelimitedText;
            p := GetClass(fn);
            if Assigned(p) then
              Exit(p);

            sl.Delete(0);
          end;

        finally
          sl.Free;
        end;
      end;
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := TClass(TObject);
end;

class function TTMSWEBPersistence.GetPropInfoDataTypeInfoClassType(APropInfo: TTMSWEBPropertyInfo): TClass;
{$IFDEF WEBLIB}
var
  t: PTypeInfo;
{$ENDIF}
begin
  {$IFNDEF WEBLIB}
  Result := GetTypeData(APropInfo^.PropType{$IFNDEF LCLLIB}^{$ENDIF})^.ClassType
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := nil;
  if Assigned(APropInfo) and Assigned(APropInfo.typeinfo) then
  begin
    t := APropInfo.typeinfo;
    asm
      if (t.class){
        return t.class.ClassType();
      }
    end;
  end;
  {$ENDIF}
end;
{$HINTS ON}

class function TTMSWEBPersistence.GetPropInfoDataTypeInfo(
  APropInfo: TTMSWEBPropertyInfo): PTypeInfo;
begin
  {$IFNDEF WEBLIB}
  Result := GetTypeData(APropInfo^.PropType{$IFNDEF LCLLIB}^{$ENDIF})^.BaseType{$IFNDEF LCLLIB}^{$ENDIF}
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := nil;
  if Assigned(APropInfo) then
    Result := APropInfo.typeinfo;
  {$ENDIF}
end;

class function TTMSWEBPersistence.GetPropInfoName(APropInfo: TTMSWEBPropertyInfo): string;
begin
  {$IFNDEF WEBLIB}
  Result := GetShortStringString(@APropInfo{$IFDEF LCLLIB}^{$ENDIF}.Name);
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := APropInfo.name;
  {$ENDIF}
end;

class function TTMSWEBPersistence.GetPropInfoType(APropInfo: TTMSWEBPropertyInfo): TTypeKind;
begin
  {$IFNDEF WEBLIB}
  Result := APropInfo^.PropType^{$IFNDEF LCLLIB}^{$ENDIF}.Kind;
  {$ENDIF}
  {$IFDEF WEBLIB}
  if Assigned(APropInfo.typeinfo) then
    Result := APropInfo.typeinfo.kind
  else
    Result := tkUnknown;
  {$ENDIF}
end;

class procedure TTMSWEBPersistence.DoCustomReadProperty(AObject: TObject;
  APropertyName: string; APropertyKind: TTypeKind; AReader: TTMSWEBJSONReader;
  var ACanRead: Boolean);
begin
  if Assigned(OnCustomReadProperty) then
    OnCustomReadProperty(AObject, APropertyName, APropertyKind, AReader, ACanRead);
end;

class procedure TTMSWEBPersistence.DoCustomWriteProperty(AObject: TObject;
  APropertyName: string; APropertyKind: TTypeKind; AWriter: TTMSWEBJSONWriter;
  var ACanWrite: Boolean);
begin
  if Assigned(OnCustomWriteProperty) then
    OnCustomWriteProperty(AObject, APropertyName, APropertyKind, AWriter, ACanWrite);
end;

class function TTMSWEBPersistence.GetEnumName(ATypeInfo: PTypeInfo; AValue: Integer): string;
begin
  {$IFNDEF WEBLIB}
  Result := TypInfo.GetEnumName(ATypeInfo, AValue);
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := TTypeInfoEnum(ATypeInfo).EnumType.IntToName[AValue];
  {$ENDIF}
end;

class function TTMSWEBPersistence.GetPropInfoTypeName(APropInfo: TTMSWEBPropertyInfo): string;
begin
  {$IFNDEF WEBLIB}
  Result := GetShortStringString(@APropInfo{$IFDEF LCLLIB}^{$ENDIF}.PropType^.Name);
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := '';
  if Assigned(APropInfo.typeinfo) then
    Result := APropInfo.typeinfo.name;
  {$ENDIF}
end;

class function TTMSWEBPersistence.IsList(AClass: TClass): boolean;
begin
  Result := IsDescendingClass(AClass, ['TList']);
end;

class function TTMSWEBPersistence.IsAssignableProperty(AObject: TObject;
  APropInfo: TTMSWEBPropertyInfo): Boolean;
var
  oProp: TObject;
  k: TTypeKind;
  pName: string;
begin
  Result := False;
  k := GetPropInfoType(APropInfo);
  if k in [tkClass] then
  begin
    pName := GetPropInfoName(APropInfo);
    oProp := GetObjectProp(AObject, pName);
    Result := (Assigned(oProp) and IsComponent(oProp.ClassType)) or not Assigned(oProp);
  end;
end;

class function TTMSWEBPersistence.IsBitmap(AClass: TClass): Boolean;
begin
  Result := IsDescendingClass(AClass, ['TBitmap', 'TPicture', 'TTMSWEBBitmap'{$IFDEF WEBLIB}, 'TGraphic'{$ENDIF}]);
end;

class function TTMSWEBPersistence.IsReadOnly(
  APropInfo: TTMSWEBPropertyInfo): Boolean;
begin
  {$IFNDEF WEBLIB}
  Result := APropInfo^.SetProc = nil;
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := APropInfo.setter = '';
  {$ENDIF}
end;

class function TTMSWEBPersistence.IsStrings(AClass: TClass): Boolean;
begin
  Result := IsDescendingClass(AClass, ['TStrings']);
end;

class function TTMSWEBPersistence.IsStrokeKind(APropertyName: string): Boolean;
begin
  Result := (APropertyName = 'TTMSWEBGraphicsStrokeKind');
end;

class function TTMSWEBPersistence.IsTime(APropertyName: string): Boolean;
begin
  Result := (APropertyName = 'TTime');
end;

class function TTMSWEBPersistence.IsWriteOnly(APropInfo: TTMSWEBPropertyInfo): Boolean;
begin
  {$IFNDEF WEBLIB}
  Result := APropInfo^.GetProc = nil;
  {$ENDIF}
  {$IFDEF WEBLIB}
  Result := APropInfo.getter = '';
  {$ENDIF}
end;

class function TTMSWEBPersistence.IsCollection(AClass: TClass): Boolean;
begin
  Result := IsDescendingClass(AClass, ['TCollection']);
end;

class function TTMSWEBPersistence.IsColor(APropertyName: string): Boolean;
begin
  Result := (APropertyName = 'TAlphaColor') or (APropertyName = 'TColor') or (APropertyName = 'TGraphicsColor');
end;

class function TTMSWEBPersistence.IsComponent(AClass: TClass): Boolean;
begin
  Result := IsDescendingClass(AClass, ['TComponent', 'TTMSWEBCustomComponent']);
end;

class function TTMSWEBPersistence.IsControl(AClass: TClass): Boolean;
begin
  Result := IsDescendingClass(AClass, ['TControl']);
end;

class function TTMSWEBPersistence.IsDate(APropertyName: string): Boolean;
begin
  Result := (APropertyName = 'TDate');
end;

class function TTMSWEBPersistence.IsDateTime(APropertyName: string): Boolean;
begin
  Result := (APropertyName = 'TDateTime');
end;

class function TTMSWEBPersistence.IsDescendingClass(AClass: TClass;
  AClassParentList: array of string): Boolean;
var
  cn: string;
  I: Integer;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    for I := 0 to Length(AClassParentList) - 1 do
    begin
      if (cn = AClassParentList[I]) then
        Exit(True);
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.IsFillKind(APropertyName: string): Boolean;
begin
  Result := (APropertyName = 'TTMSWEBGraphicsFillKind');
end;

class function TTMSWEBPersistence.IsGenericDictionary(AClass: TClass): Boolean;
var
  cn: string;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<', cn) or AnsiStartsStr('TObjectDictionary<', cn) then
      Exit(True);
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.IsGenericStringDictionary(AClass: TClass): Boolean;
var
  cn: string;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<string', cn) or AnsiStartsStr('TObjectDictionary<string', cn) or
      AnsiStartsStr('TDictionary<System.string', cn) or AnsiStartsStr('TObjectDictionary<System.string', cn) then
        Exit(True);
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.IsGenericIntegerDictionary(AClass: TClass): Boolean;
var
  cn: string;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TDictionary<Integer', cn) or AnsiStartsStr('TObjectDictionary<Integer', cn) or
      AnsiStartsStr('TDictionary<System.Integer', cn) or AnsiStartsStr('TObjectDictionary<System.Integer', cn) or
        AnsiStartsStr('TDictionary<System.Longint', cn) or AnsiStartsStr('TObjectDictionary<System.Longint', cn) then
          Exit(True);
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.IsGenericList(AClass: TClass; AType: string = ''): Boolean;
var
  cn: string;
begin
  if not Assigned(AClass) then
    Exit(False);
  repeat
    cn := AClass.ClassName;
    if AnsiStartsStr('TList<', cn) or AnsiStartsStr('TObjectList<', cn) then
    begin
      if (AType = '') or ((AType <> '') and (Pos(LowerCase(AType), LowerCase(cn)) > 0) or (Pos(LowerCase(AType), LowerCase(cn)) > 0)) then
        Exit(True);
    end;
    AClass := AClass.ClassParent;
  until not Assigned(AClass);
  Result := False;
end;

class function TTMSWEBPersistence.CreateObject(const AClassName: string;
  BaseClass: TClass): TObject;
var
  ObjType: TPersistentClass;
begin
  ObjType := GetClass(AClassName);
  if (ObjType = nil) then
  begin
    if TTMSWEBPersistence.IgnoreExceptions then
    begin
      Result := nil;
      Exit;
    end
    else
      raise ETMSWEBReaderException.CreateFmt('Type "%s" not found', [AClassName]);
  end;
  
  if not TTMSWEBPersistence.IgnoreExceptions then
  begin
    if not ObjType.InheritsFrom(TObject) then
      raise ETMSWEBReaderException.Create('Type "%s" is not an class type');
    
    if BaseClass <> nil then
      if not ObjType.InheritsFrom(BaseClass) then
        raise ETMSWEBReaderException.CreateFmt('Type "%s" does not inherit from %s',
          [AClassName, BaseClass.ClassName]);
  end;

  {$IFNDEF RTLONLY}
  {$IFDEF CMNWEBLIB}
  if ObjType.InheritsFrom(TCustomControl) then
    Result := TCustomControlClass(ObjType).Create(nil)
  {$ENDIF}
  {$IFDEF FMXLIB}
  if ObjType.InheritsFrom(TControl) then
    Result := TControlClass(ObjType).Create(nil)
  else if ObjType.InheritsFrom(TComponent) then
    Result := TComponentClass(ObjType).Create(nil)
  {$ENDIF}
  {$ELSE}
  if ObjType.InheritsFrom(TComponent) then
    Result := TComponentClass(ObjType).Create(nil)
  {$ENDIF}
  else if ObjType.InheritsFrom(TCollectionItem) then
    Result := TCollectionItemClass(ObjType).Create(nil)
  else if ObjType.InheritsFrom(TPersistent) then
    Result := TPersistentClass(ObjType).Create
  else
    raise ETMSWEBReaderException.CreateFmt('Type "%s" not supported', [AClassName]);
end;

{ TTMSWEBObjectPersistence }

class procedure TTMSWEBObjectPersistence.LoadObjectFromString(AObject: TObject; AString: string);
var
  ms: TStringStream;
begin
  ms := TStringStream.Create(AString{$IFDEF WEBLIB}, TEncoding.UTF8{$ENDIF});
  try
    TTMSWEBPersistence.LoadSettingsFromStream(AObject, ms);
  finally
    ms.Free;
  end;
end;

class function TTMSWEBObjectPersistence.SaveObjectToString(
  AObject: TObject): string;
var
  ss: TStringStream;
begin
  ss := TStringStream.Create(''{$IFDEF WEBLIB}, TEncoding.UTF8{$ENDIF});
  try
    TTMSWEBPersistence.SaveSettingsToStream(AObject, ss);
    ss.Position := 0;
    Result := ss.DataString;
  finally
    ss.Free;
  end;
end;

{$IFDEF FNCLIB}

{ TTMSWEBJSONToClass }

class procedure TTMSWEBJSONToClass.JSONValueToClass(AParentProperty: TTMSWEBJSONToClassProperty; AJSONValue: TJSONValue);
var
  v: TJSONValue;
  n: string;
  p: TTMSWEBJSONToClassProperty;
  sz: Integer;
  K: Integer;
  t: TTMSWEBJSONToClassPropertyType;
  ci: TTMSWEBJSONToClassItem;
begin
  if AJSONValue is TJSONObject then
  begin
    ci := TTMSWEBJSONToClassItem.Create(AParentProperty);
    FClasses.Add(ci);

    sz := TTMSWEBUtils.GetJSONObjectSize(AJSONValue as TJSONObject);
    for k := 0 to sz - 1 do
    begin
      n := TTMSWEBUtils.GetJSONObjectName(AJSONValue as TJSONObject, k);
      v := TTMSWEBUtils.GetJSONValue(AJSONValue, n);

      p := nil;
      if Assigned(v) then
      begin
        t := JSONValueToPropertyType(v);
        if t <> cptUndefined then
        begin
          p := TTMSWEBJSONToClassProperty.Create(n, t);
          ci.Properties.Add(p);
        end;
      end;

      JSONValueToClass(p, v);
    end;
  end
  else if AJSONValue is TJSONArray then
  begin
    if TTMSWEBUtils.GetJSONArraySize(AJSONValue as TJSONArray) > 0 then
    begin
      t := JSONValueToPropertyType(AJSONValue);
      v := TTMSWEBUtils.GetJSONArrayItem(AJSONValue as TJSONArray, 0);
      if not Assigned(AParentProperty) and (t <> cptUndefined) then
      begin
        ci := TTMSWEBJSONToClassItem.Create(nil);
        p := TTMSWEBJSONToClassProperty.Create('Items', t);
        ci.Properties.Add(p);
        FClasses.Add(ci);
        AParentProperty := p;
      end;

      JSONValueToClass(AParentProperty, v);
    end
    else
    begin
      ci := TTMSWEBJSONToClassItem.Create(AParentProperty);
      FClasses.Add(ci);
    end;
  end
  else
  begin

  end;
end;

class function TTMSWEBJSONToClass.JSONValueToPropertyType(
  AJSONValue: TJSONValue): TTMSWEBJSONToClassPropertyType;
var
  s: string;
  dt: TDateTime;
  b: Boolean;
  v: TJSONValue;
  p: TTMSWEBJSONToClassPropertyType;
  d: Double;
  i: Integer;
  i64: Int64;
begin
  Result := cptUndefined;
  if not Assigned(AJSONValue) then
    Exit;

  if AJSONValue is TJSONObject then
    Result := cptObject
  else if AJSONValue is TJSONArray then
  begin
    Result := cptObjectArray;
    if TTMSWEBUtils.GetJSONArraySize(AJSONValue as TJSONArray) > 0 then
    begin
      v := TTMSWEBUtils.GetJSONArrayItem(AJSONValue as TJSONArray, 0);
      if Assigned(v) then
      begin
        p := JSONValueToPropertyType(v);
        case p of
          cptString: Result := cptStringArray;
          cptBoolean: Result := cptBooleanArray;
          cptDateTime: Result := cptDateTimeArray;
          cptObject: Result := cptObjectArray;
          cptDouble: Result := cptDoubleArray;
          cptInteger: Result := cptIntegerArray;
          cptInteger64: Result := cptInteger64Array;
        end;
      end;
    end;
  end
  else if AJSONValue is TJSONNumber then
  begin
    s := AJSONValue.Value;
    if TryStrToInt(s, i) then
      Result := cptInteger
    else if TryStrToInt64(s, i64) then
      Result := cptInteger64
    else if not TTMSWEBUtils.TryStrToFloatDot(s, d) then
      Result := cptString
    else
      Result := cptDouble;
  end
  {$IFDEF LCLLIB}
  else if AJSONValue is TJSONBoolean then
    Result := cptBoolean
  {$ENDIF}
  {$IFNDEF LCLLIB}
  else if (AJSONValue is TJSONTrue) or (AJSONValue is TJSONFalse) then
    Result := cptBoolean
  {$ENDIF}
  else if AJSONValue is TJSONString then
  begin
    s := AJSONValue.Value;

    if TTMSWEBUtils.TryStrToFloatDot(s, d) then
      Result := cptString
    else if TTMSWEBUtils.IsDate(s, dt) or {$IFDEF FNCLIB}(TTMSWEBUtils.ISOToDateTime(s, True) > 0) or{$ENDIF} TryStrToDateTime(s, dt) then
      Result := cptDateTime
    else if TryStrToBool(s, b) then
      Result := cptBoolean
    else
      Result:= cptString;
  end;
end;

class function TTMSWEBJSONToClass.ExportToDelphiFromFile(AFileName: string; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string;
begin
  Result := ExportToDelphiFromFile(AFileName, DefaultJSONToClassOptions, ACallBack);
end;

class function TTMSWEBJSONToClass.ExportToDelphi(AJSONString: string; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string;
begin
  Result := ExportToDelphi(AJSONString, DefaultJSONToClassOptions, ACallBack);
end;

class function TTMSWEBJSONToClass.ExportToDelphi(AJSONValue: TJSONValue; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string;
begin
  Result := ExportToDelphi(AJSONValue.ToString, DefaultJSONToClassOptions, ACallBack);
end;

class function TTMSWEBJSONToClass.ExportToDelphiFromFile(AFileName: string; AOptions: TTMSWEBJSONToClassOptions; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string;
var
  sl: TStringList;
begin
  sl := TStringList.Create;
  try
    sl.LoadFromFile(AFileName);
    Result := ExportToDelphi(sl.Text, AOptions, ACallBack);
  finally
    sl.Free;
  end;
end;

{$IFDEF LCLLIB}
function CompareNameVal(const Item1, Item2: TTMSWEBJSONToClassProperty): Integer;
begin
  Result := CompareText(Item1.Name, Item2.Name);
end;
{$ENDIF}

class function TTMSWEBJSONToClass.ExportToDelphi(AJSONValue: TJSONValue; AOptions: TTMSWEBJSONToClassOptions; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string;
begin
  Result := ExportToDelphi(AJSONValue.ToString, AOptions, ACallBack);
end;

class function TTMSWEBJSONToClass.ExportToDelphi(AJSONString: string; AOptions: TTMSWEBJSONToClassOptions; ACallBack: TTMSWEBJSONToClassExportEvent = nil): string;
var
  root: TJSONValue;
  I, K: Integer;
  c: TTMSWEBJSONToClassItem;
  sl: TStringList;
  p: TTMSWEBJSONToClassProperty;
  ind: string;
  cn: string;
  slRendered: TStringList;

  procedure SortList(const AList: TTMSWEBJSONToClassProperties);
  {$IFNDEF LCLWEBLIB}
  var
    cmp: TTMSWEBJSONToClassPropertyNameComparer;
  {$ENDIF}
  begin
    {$IFNDEF LCLWEBLIB}
    cmp := TTMSWEBJSONToClassPropertyNameComparer.Create;
    try
      AList.Sort(cmp);
    finally
      cmp.Free;
    end;
    {$ENDIF}
    {$IFDEF LCLLIB}
    AList.Sort(@CompareNameVal);
    {$ENDIF}
    {$IFDEF WEBLIB}
    AList.Sort(TComparer<TTMSWEBJSONToClassProperty>.Construct(
      function(const ALeft, ARight: TTMSWEBJSONToClassProperty): Integer
      begin
        Result := CompareText(ALeft.Name, ARight.Name);
      end));
    {$ENDIF}
  end;
begin
  root := TTMSWEBUtils.ParseJSON(AJSONString);
  if Assigned(root) then
  begin
    try
      FClasses := TTMSWEBJSONToClassItems.Create;
      try
        JSONValueToClass(nil, root);

        sl := TStringList.Create;
        slRendered := TStringList.Create;
        try
          {$IFNDEF LCLLIB}
          {$HINTS OFF}
          {$IF COMPILERVERSION > 30}
          sl.TrailingLineBreak := False;
          {$IFEND}
          {$HINTS ON}
          {$ENDIF}

          ind := '';
          if AOptions.AddUnit then
          begin
            sl.Add('unit MyDelphiUnit;');
            sl.Add('');
            sl.Add('interface');
            sl.Add('');
            sl.Add('uses');
            sl.Add('  Classes, System.Generics.Collections;');
            sl.Add('');
            sl.Add('type');
            ind := '  ';
          end;

          for I := FClasses.Count - 1 downto 0 do
          begin
            c := FClasses[I];
            cn := c.GetClassName(ACallBack, AOptions);
            if slRendered.IndexOf(cn) = -1 then
            begin
              case AOptions.BaseClass of
                cbcNone: sl.Add(ind + cn + ' = class');
                cbcPersistent: sl.Add(ind + cn + ' = class(TPersistent)');
              end;

              if AOptions.SortProperties then
                SortList(c.Properties);


              if c.Properties.Count > 0 then
              begin
                sl.Add(ind + 'private');
                for K := 0 to c.Properties.Count - 1 do
                begin
                  p := c.Properties[K];
                  sl.Add(ind + '  F' + p.DelphiName(ACallBack, AOptions, False) + ': ' + p.DelphiType(ACallBack, AOptions) + ';');
                end;
              end;

              if AOptions.AddConstructor or AOptions.AddDestructor or AOptions.AddAssign then
              begin
                sl.Add(ind + 'public');

                if AOptions.AddAssign then
                begin
                  case AOptions.BaseClass of
                    cbcNone: sl.Add(ind + '  procedure Assign(Source: TObject);');
                    cbcPersistent: sl.Add(ind + '  procedure Assign(Source: TPersistent); override;');
                  end;
                end;

                if AOptions.AddConstructor then
                  sl.Add(ind + '  constructor Create;');

                if AOptions.AddDestructor then
                  sl.Add(ind + '  destructor Destroy; override;');
              end;

              if c.Properties.Count > 0 then
              begin
                sl.Add(ind + 'published');
                for K := 0 to c.Properties.Count - 1 do
                begin
                  p := c.Properties[K];
                  sl.Add(ind + '  property ' + p.DelphiName(ACallBack, AOptions) + ': ' + p.DelphiType(ACallBack, AOptions) + ' read F' + p.DelphiName(ACallBack, AOptions, False) + ' write F' + p.DelphiName(ACallBack, AOptions, False) + ';');
                end;
              end;

              sl.Add(ind + 'end;');
              sl.Add('');

              slRendered.Add(cn);
            end;
          end;

          slRendered.Clear;

          if AOptions.AddUnit then
          begin
            sl.Add('implementation');
            sl.Add('');
            if AOptions.AddImplementation then
            begin
              slRendered.Clear;

              for I := FClasses.Count - 1 downto 0 do
              begin
                c := FClasses[I];

                cn := c.GetClassName(ACallBack,AOptions);
                if slRendered.IndexOf(cn) = -1 then
                begin
                  if AOptions.AddConstructor or AOptions.AddDestructor or AOptions.AddAssign then
                  begin
                    sl.Add('{ ' + c.GetClassName(ACallBack, AOptions)  + ' }');
                    sl.Add('');

                    if AOptions.AddAssign then
                    begin
                      case AOptions.BaseClass of
                        cbcNone: sl.Add('procedure ' + cn + '.Assign(Source: TObject);');
                        cbcPersistent: sl.Add('procedure ' + cn + '.Assign(Source: TPersistent);');
                      end;

                      sl.Add('begin');
                      sl.Add('  if (Source is ' + cn + ') then');
                      sl.Add('  begin');
                      for K := 0 to c.Properties.Count - 1 do
                      begin
                        p := c.Properties[K];
                        if (p.&Type = cptObject) then
                          sl.Add('    F' + p.DelphiName(ACallBack, AOptions, False) + '.Assign((Source as ' + cn + ').' + p.DelphiName(ACallBack, AOptions, True) + ');')
                        else if not p.IsObject then
                          sl.Add('    F' + p.DelphiName(ACallBack, AOptions, False) + ' := (Source as ' + cn + ').' + p.DelphiName(ACallBack, AOptions, True) + ';')
                        else
                          sl.Add('    //F' + p.DelphiName(ACallBack, AOptions, False) + ' := (Source as ' + cn + ').' + p.DelphiName(ACallBack, AOptions, True) + '; //implement list copy');
                      end;
                      sl.Add('  end;');
                      sl.Add('end;');
                      sl.Add('');
                    end;

                    if AOptions.AddConstructor then
                    begin
                      sl.Add('constructor ' + cn + '.Create;');
                      sl.Add('begin');
                      sl.Add('  inherited;');
                      for K := 0 to c.Properties.Count - 1 do
                      begin
                        p := c.Properties[K];
                        if p.IsObject then
                          sl.Add('  F' + p.DelphiName(ACallBack, AOptions, False) + ' := ' + p.DelphiType(ACallBack, AOptions) + '.Create;');
                      end;
                      sl.Add('end;');
                      sl.Add('');
                    end;

                    if AOptions.AddDestructor then
                    begin
                      sl.Add('destructor ' + cn + '.Destroy;');
                      sl.Add('begin');
                      for K := 0 to c.Properties.Count - 1 do
                      begin
                        p := c.Properties[K];
                        if p.IsObject then
                          sl.Add('  F' + p.DelphiName(ACallBack, AOptions, False) + '.Free;');
                      end;
                      sl.Add('  inherited;');
                      sl.Add('end;');
                      sl.Add('');
                    end;

                    slRendered.Add(cn);
                  end;
                end;
              end;
            end;

            sl.Add('end.');
          end;

          while sl.Count > 0 do
          begin
            if sl[sl.Count - 1] = '' then
              sl.Delete(sl.Count - 1)
            else
              Break;
          end;

          Result := sl.Text;
        finally
          slRendered.Free;
          sl.Free;
        end;

      finally
        FClasses.Free;
      end;
    finally
      root.Free;
    end;
  end;
end;

{ TTMSWEBJSONToClassItem }

constructor TTMSWEBJSONToClassItem.Create(
  AParentProperty: TTMSWEBJSONToClassProperty);
begin
  FParentProperty := AParentProperty;
end;

destructor TTMSWEBJSONToClassItem.Destroy;
begin
  if Assigned(FProperties) then
    FProperties.Free;
  inherited;
end;

function TTMSWEBJSONToClassItem.GetClassName(ACallBack: TTMSWEBJSONToClassExportEvent; AOptions: TTMSWEBJSONToClassOptions): string;
begin
  Result := 'TMyDelphiClass';
  if Assigned(ParentProperty) then
    Result := 'T' + ParentProperty.DelphiName(ACallBack, AOptions, False);
end;

function TTMSWEBJSONToClassItem.GetProperties: TTMSWEBJSONToClassProperties;
begin
  if not Assigned(FProperties) then
    FProperties := TTMSWEBJSONToClassProperties.Create;

  Result := FProperties;
end;

{ TTMSWEBJSONToClassProperty }

constructor TTMSWEBJSONToClassProperty.Create(AName: string;
  AType: TTMSWEBJSONToClassPropertyType);
begin
  FName := AName;
  FType := AType;
end;

function TTMSWEBJSONToClassProperty.DelphiName(ACallBack: TTMSWEBJSONToClassExportEvent; AOptions: TTMSWEBJSONToClassOptions; AFixKeyWord: Boolean = True): string;
var
  n, s: string;
  c: Char;
  sl: TStringList;
  I: Integer;
  p: string;
  pt: TTMSWEBJSONToClassPropertyType;
begin
  Result := '';
  if Length(Name) > 0 then
  begin
    p := Name;
    pt := &Type;

    if Assigned(ACallBack) then
      ACallBack(p, pt);

    sl := TStringList.Create;
    try

      if AOptions.RemoveSpecialCharacters then
      begin
        s := p;
        p := '';

        for c in s do
        begin
          if TTMSWEBUtils.IsLetterOrDigit(c) then
            p := p + c
          else
            p := p + '_'
        end;
      end;

      TTMSWEBUtils.Split('_', p, sl);

      for I := 0 to sl.Count - 1 do
      begin
        n := sl[I];

        if Length(n) > 0 then
        begin
          if AOptions.DelphiCasing then
            n := UpperCase(n[{$IFNDEF ZEROSTRINGINDEX}1{$ELSE}0{$ENDIF}]) + Copy(n, 2, Length(n) - 1);
        end;

        Result := Result + n;
      end;

      if AFixKeyWord then
        Result := FixKeyWord(Result);

    finally
      sl.Free;
    end;
  end;
end;

function TTMSWEBJSONToClassProperty.DelphiType(ACallBack: TTMSWEBJSONToClassExportEvent; AOptions: TTMSWEBJSONToClassOptions): string;
var
  n: string;
  t: TTMSWEBJSONToClassPropertyType;
begin
  Result := '';

  n := Name;
  t := FType;
  if Assigned(ACallBack) then
    ACallBack(n, t);

  case t of
    cptUndefined: Result := 'UNDEFINED';
    cptString: Result := 'string';
    cptBoolean: Result := 'Boolean';
    cptDateTime: Result := 'TDateTime';
    cptObject: Result := 'T' + DelphiName(ACallback, AOptions, False);
    cptDouble: Result := 'Double';
    cptInteger: Result := 'Integer';
    cptInteger64: Result := 'Int64';
    cptObjectArray: Result := 'TObjectList<' + 'T' + DelphiName(ACallback, AOptions, False) + '>';
    cptDoubleArray: Result := 'TList<Double>';
    cptStringArray: Result := 'TList<string>';
    cptBooleanArray: Result := 'TList<Boolean>';
    cptDateTimeArray: Result := 'TList<TDateTime>';
    cptIntegerArray: Result := 'TList<Integer>';
    cptInteger64Array: Result := 'TList<Int64>';
  end;
end;

function TTMSWEBJSONToClassProperty.FixKeyWord(AValue: string): string;
const
  a: array[0..64] of string = ('and','array', 'as', 'asm', 'begin',
                               'case', 'class', 'const', 'constructor', 'destructor',
                               'dispinterface', 'div',	'do',	'downto',	'else',
                               'end',	'except',	'exports',	'file',	'finalization',
                               'finally',	'for',	'function',	'goto',	'if',
                               'implementation',	'in',	'inherited',	'initialization',	'inline',
                               'interface',	'is',	'label',	'library', 'mod',
                               'nil',	'not',	'object',	'of',	'or',
                               'out',	'packed',	'procedure',	'program', 'property',
                               'raise',	'record',	'repeat',	'resourcestring',	'set',
                               'shl',	'shr',	'string',	'then',	'threadvar',
                               'to',	'try',	'type',	'unit',	'until',
                               'uses',	'var',	'while',	'with',	'xor');
begin
  Result := AValue;
  if TTMSWEBUtils.IndexOfTextInArray(UpperCase(AValue), a) <> -1 then
    Result := '&' + AValue;
end;

function TTMSWEBJSONToClassProperty.IsObject: Boolean;
begin
  Result := &Type in [cptObject, cptObjectArray, cptStringArray, cptBooleanArray, cptDateTimeArray, cptDoubleArray, cptIntegerArray, cptInteger64Array];
end;

{ TTMSWEBJSONToClassPropertyNameComparer }

{$IFNDEF LCLWEBLIB}
function TTMSWEBJSONToClassPropertyNameComparer.Compare(const Left,
  Right: TTMSWEBJSONToClassProperty): Integer;
begin
  Result := CompareText(Left.Name, Right.Name);
end;
{$ENDIF}
{$ENDIF}


initialization
begin
  TTMSWEBPersistence.ClassTypeVariable := '$type';
  TTMSWEBPersistence.IgnoreExceptions := False;
end;

end.


